import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CanvasTimeline from './../canvas-timeline/canvas_timeline';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import Moment, * as moment from 'moment';
import _ from 'lodash';

import PersonGroup from './groups/person_group';
import ProjectGroup from './groups/project_group';
import NonProjectTimeGroup from './groups/non_project_time_group';
import PersonAllocationsGroup from './groups/person_allocations_group';
import PlaceholderGroup from './groups/placeholder_group';
import UnassignedRoleGroup from './groups/unassigned_role_group';
import UnassignedRoleTaskGroup from './groups/unassigned_role_task_group';
import CompanyUtilizationGroup from './groups/company_utilization_group';
import {
	areItemDatesValid,
	createCanvasTimelineDate,
	DRAGGABLE_TYPE,
	getCanvasTimelineDateFromMoment,
	getHolidayDates,
	getMinutesInWeekdays,
	getMomentFromCanvasTimelineDate,
	getPersonGroups,
	getWeekdaysBetweenDates,
	GROUP_TYPE,
	HEATMAP_CHECKMARK_LENIENCY_PERCENTAGE,
	isDateWithinPersonStartEndDate,
	ITEM_TYPE,
	MIN_DATE_YEAR,
	setTimestampCorrelationId,
	setTimestampDataLoaded,
	setTimestampLabel,
	GROUP_SECTION_ACTIONS_MENU_LEFT_SCHEDULE_PEOPLE,
	GROUP_SECTION_ACTION_BUTTON_SIZE,
} from '../canvas-timeline/canvas_timeline_util';
import Util from '../../../forecast-app/shared/util/util';
import ActionMenu from '../action_menu';
import {
	BUTTON_COLOR,
	BUTTON_STYLE,
	ESTIMATION_UNIT,
	PROJECT_STATUS,
	projectGroupUrl,
	projectUrl,
	SCHEDULING_ACTION_MENU_TYPE,
} from '../../../constants';
import HeatmapItem from './items/heatmap_item';
import TimeOffItem from './items/timeoff_item';
import UnassignedHeatmapItem from './items/unassigned_heatmap_item';
import {ProjectAllocationItem} from './items/project_allocation_item';
import TaskItem from './items/task_item';
import CompanyUtilizationItem from './items/company_utilization_item';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {updateTask} from '../../scheduling/scheduling_mutations';
import {dispatch, EVENT_ID, subscribe, unsubscribe} from '../../../containers/event_manager';
import CompanyUtilizationWebWorker from './company_utilization.worker.js';
import Warning from '../../../components/warning';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';
import ProjectGroupInfoBox from './project_group_info_box';
import TaskDetailBox from '../components/task_detail_box';
import AllocationDetailBox from '../components/allocation_detail_box';
import * as tracking from '../../../tracking';
import {getPeopleEyeOptions} from './people_scheduling_options';
import {createHeader, getTopHeaderContent, GROUP_BY} from './people_scheduling_header';
import {fetchInit} from '../scheduling_fetch';
import {fetchData, fetchLightweightData} from './people_scheduling_fetch';
import {createLightWeightPersonGroupsAndItems} from './people_scheduling_lightweight';
import {LoadingGroup} from './groups/loading_group';
import {handleNotification} from './people_scheduling_socket';
import FreeDayItem from './items/freeday_item';
import {onAllocationContextMenu, onTaskContextMenu} from '../canvas_scheduling_context_menu';
import ContextMenu from '../../../forecast-app/shared/components/context-menus/context_menu';
import {handlePeopleSchedulingMutation} from './people_scheduling_mutation_success';
import {getFilterFunctions} from '../../../forecast-app/shared/components/filters/filter_logic';
import {
	drawLoadMoreOverlay,
	isStepHiddenByLoadMore,
	LoadMoreOverlay,
	preventScrollingPastLoadMoreOverlay,
} from './load-more-overlay';
import TrackPersonEventMutation from '../../../mutations/track_person_event_mutation';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../../forecast-app/shared/components/headers/top-header-bar/TopHeaderBar';
import PersonGroupingGroup from './groups/person_grouping_group';
import PersonGroupUtilizationItem from './items/person_group_utilization_item';
import {hasPermission, isClientUser} from '../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';
import {calculatePersonGroupUtilization} from './person_group_utilization_calculator';
import {handleRemovePerson} from '../actions/handle_remove_person';
import {hasFeatureFlag} from '../../../forecast-app/shared/util/FeatureUtil';
import {UTILIZATION_FORMAT} from '../canvas-timeline/canvas_timeline_util';

class CanvasPeopleScheduling extends Component {
	constructor(props) {
		super(props);
		setTimestampCorrelationId();
		setTimestampLabel('People Scheduling');

		const todayDate = getCanvasTimelineDateFromMoment(Moment());

		const labelFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-label')) || [];
		const projectFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-project')) || [];
		const clientFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-client')) || [];
		const roleFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-role')) || [];
		const projectStatusFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-projectStatus')) || [];
		const projectStageFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-projectStage')) || [];
		const personFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-person')) || [];
		const teamFilterValue = JSON.parse(localStorage.getItem('canvas-scheduling-filter-value-team')) || [];

		this.state = {
			dataLoaded: false,
			isCollapsableSectionExpanded: false,
			todayDate,
			labelFilterValue,
			projectFilterValue,
			clientFilterValue,
			roleFilterValue,
			projectStatusFilterValue,
			projectStageFilterValue,
			personFilterValue,
			teamFilterValue,
			searchFilterValue: '',
			hasInitialWorkerRun: false,
			splitAllocationBarData: {},
		};

		this.heatmapCache = this.props.heatmapCache;
		this.personGroupUtilizationCache = new Map();
		this.companyUtilizationCache = new Map();
		this.companyUtilizationWebWorker = new CompanyUtilizationWebWorker();
		this.companyUtilizationWebWorker.addEventListener('message', e => {
			if (this.getViewer().email.endsWith('forecastit.dk')) {
				document.getElementById('CompanyUtilCalculated').textContent =
					document.getElementById('CompanyUtilCalculated').textContent + '1';
			}
			const {dateString, minutesAllocated, minutesAvailable} = e.data;
			this.companyUtilizationCache.set(dateString, {minutesAllocated, minutesAvailable, needsRecalculation: false});
			if (this.companyUtilizationRedrawTimeout) {
				clearTimeout(this.companyUtilizationRedrawTimeout);
			}
			this.companyUtilizationRedrawTimeout = setTimeout(() => {
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
			}, 300);
		});
		this.onSchedulingModalMutationSuccess = this.onSchedulingModalMutationSuccess.bind(this);
		subscribe(EVENT_ID.SCHEDULING_MODAL_MUTATION_SUCCESS, this.onSchedulingModalMutationSuccess);

		this.onKeyPress = this.onKeyPress.bind(this);

		this.itemGenerator = this.itemCreationGenerator();

		this.onSavedFiltersUpdate = this.onSavedFiltersUpdate.bind(this);
		subscribe(EVENT_ID.SAVED_FILTERS_UPDATE, this.onSavedFiltersUpdate);
		this.handleSocketNotify = this.handleSocketNotify.bind(this);

		fetchInit().then(initData => {
			this.setState(
				{
					initData,
				},
				() => {
					this.isUsingNewTRU = this.state.initData.featureFlags.some(
						featureFlag => featureFlag.key === 'heatmap_resource_utilization'
					);

					let peopleSchedulingOptions = {
						hideEmpty: localStorage.getItem('peopleScheduling_hideEmpty')
							? localStorage.getItem('peopleScheduling_hideEmpty') === 'true'
							: false,
						groupBy: localStorage.getItem('peopleScheduling_groupBy')
							? localStorage.getItem('peopleScheduling_groupBy')
							: GROUP_BY.NONE,
						utilizationFormat:
							hasFeatureFlag('resource_utilization_format') &&
							localStorage.getItem('peopleScheduling_utilizationFormat')
								? localStorage.getItem('peopleScheduling_utilizationFormat')
								: UTILIZATION_FORMAT.HOURS,
					};
					this.setState({
						peopleSchedulingOptions,
						allDataLoaded: false,
						allDataLoading: false,
					});
					this.peopleEyeOptions = getPeopleEyeOptions(this.state.initData.company.isUsingProjectAllocation);
					this.setState({
						peopleSchedulingDetailSelectorOptions: this.peopleEyeOptions,
					});

					const hasLightWeightFeatureFlag = initData.featureFlags.find(
						featureFlag => featureFlag.key === 'use_lightweight_people_scheduling'
					);
					if (hasLightWeightFeatureFlag) {
						this.doFetchLightWeightData(props, initData);
					} else {
						this.doFetchFullData(props, false);
					}
				}
			);
		});
	}

	componentDidMount() {
		Util.CommitMutation(TrackPersonEventMutation, {
			name: 'scheduling-people',
		});
		tracking.trackPage('scheduling-team');

		this.props.setTimeline(this.timeline);
		window.addEventListener('click', this.onClick.bind(this));
		window.addEventListener('keypress', this.onKeyPress);

		subscribe(EVENT_ID.SOCKET_NOTIFY, this.handleSocketNotify);
	}

	componentWillUnmount() {
		window.removeEventListener('click', this.onClick.bind(this));
		window.removeEventListener('keypress', this.onKeyPress);
		unsubscribe(EVENT_ID.SCHEDULING_MODAL_MUTATION_SUCCESS, this.onSchedulingModalMutationSuccess);

		unsubscribe(EVENT_ID.SOCKET_NOTIFY, this.handleSocketNotify);
	}

	createRelayTeamDataStructure(data) {
		return [
			...data.teams.map(team => {
				const teamPersonsForTeam = data.teamPersonByTeamMap[team.id] || [];
				return {
					node: {
						...team,
						id: btoa(`Team:${team.id}`),
						teamPersons: {
							edges: teamPersonsForTeam.map(tp => {
								return {node: {...tp, person: {id: tp.personId}}};
							}),
						},
					},
				};
			}),
			{
				node: {
					id: null,
					teamPersons: {
						edges: data.teamPersons.map(tp => {
							return {node: {...tp, person: {id: tp.personId}}};
						}),
					},
				},
			},
		];
	}

	doFetchLightWeightData(props, initData) {
		fetchLightweightData().then(lightWeightData => {
			setTimestampDataLoaded();

			if (!lightWeightData) {
				showModal({
					type: MODAL_TYPE.MUTATION_ERROR,
					isNetworkError: false,
					reload_to_upcoming: true,
				});
				return;
			}

			if (isClientUser()) {
				props.history.push(
					props.isProjectTimeline
						? `/project/${props.match.params.projectGroupId ? 'X' : 'P'}-${
								props.match.params.projectGroupId || props.match.params.projectId
						  }/workflow`
						: '/'
				);
				return;
			}

			const {viewer} = lightWeightData;

			let filters;
			let filterString = `canvas-scheduling-filters-v4-people`;
			if (localStorage.getItem(filterString) === 'undefined') {
				localStorage.removeItem(filterString);
			}
			if (localStorage.getItem(filterString)) {
				filters = JSON.parse(localStorage.getItem(filterString));
			} else {
				filters = {
					person: {},
					task: {},
					project: {},
				};
			}

			const filterFunctions = getFilterFunctions(filters);

			if (initData.company.isUsingProjectAllocation) {
				// if the  company.isUsingProjectAllocation igonre the task filters saved in the localStorage
				filters.task = {};
			}

			lightWeightData.persons.forEach(person => {
				person.startDate = person.startDate
					? getCanvasTimelineDateFromMoment(moment.utc(person.startDate, 'YYYY-MM-DD'))
					: null;
				person.endDate = person.endDate
					? getCanvasTimelineDateFromMoment(moment.utc(person.endDate, 'YYYY-MM-DD'))
					: null;
			});

			// Lookup maps
			lightWeightData.projectMap = new Map(lightWeightData.projects.map(project => [project.id, project]));
			lightWeightData.projectByProjectGroupMap = _.groupBy(lightWeightData.projects, 'projectGroupId');
			lightWeightData.projectPersonByProjectMap = _.groupBy(lightWeightData.projectPersons, 'projectId');
			lightWeightData.projectPersonByPersonMap = _.groupBy(lightWeightData.projectPersons, 'personId');
			lightWeightData.projectLabelByProjectMap = _.groupBy(lightWeightData.projectLabels, 'projectId');
			lightWeightData.personLabelByPersonMap = _.groupBy(lightWeightData.personLabels, 'personId');
			lightWeightData.personSkillsByPersonMap = _.groupBy(lightWeightData.personSkills, 'personId');
			lightWeightData.teamPersonByTeamMap = _.groupBy(lightWeightData.teamPersons, 'teamId');
			lightWeightData.teamsRelay = this.createRelayTeamDataStructure(lightWeightData);
			lightWeightData.featureFlags = initData.featureFlags;

			const {groups, items} = createLightWeightPersonGroupsAndItems(this, props, lightWeightData, this.peopleEyeOptions);

			this.setState(
				{
					viewer,
					lightWeightData,
					groups,
					collapsableSectionGroups: [new LoadingGroup({})],
					items,
					dataLoaded: true,
					filters,
					peopleSchedulingDetailSelectorOptions: this.peopleEyeOptions,
					filterFunctions,
				},
				() => {
					dispatch(EVENT_ID.PAGE_LOADED, 'people_scheduling_light');

					this.doFetchFullData(props, false);
				}
			);
		});
	}

	doFetchFullData(props, loadAllData = false) {
		fetchData(loadAllData).then(dataArray => {
			const data = dataArray[0];
			if (!data || data.error) {
				showModal({
					type: MODAL_TYPE.MUTATION_ERROR,
					isNetworkError: false,
					reload_to_upcoming: true,
				});
			} else {
				data.persons.forEach(person => {
					person.startDate = person.startDate
						? getCanvasTimelineDateFromMoment(moment.utc(person.startDate, 'YYYY-MM-DD'))
						: null;
					person.endDate = person.endDate
						? getCanvasTimelineDateFromMoment(moment.utc(person.endDate, 'YYYY-MM-DD'))
						: null;
				});
				this.resetState(props, data, loadAllData);
			}
		});
	}

	resetState(props, data, loadAllData = false) {
		if (isClientUser()) {
			this.props.history.push(
				props.isProjectTimeline
					? `/project/${props.match.params.projectGroupId ? 'X' : 'P'}-${
							props.match.params.projectGroupId || props.match.params.projectId
					  }/workflow`
					: '/'
			);
			return;
		}
		this.isItemGenerationComplete = false;
		this.currentItemCreationGeneratorStep = null;
		this.itemGenerator = this.itemCreationGenerator();

		// Lookup maps
		data.projectMap = new Map(data.projects.map(project => [project.id, project]));
		data.projectGroupMap = new Map(data.projectGroups.map(projectGroup => [projectGroup.id, projectGroup]));
		data.projectByProjectGroupMap = _.groupBy(data.projects, 'projectGroupId');
		data.projectPersonByProjectMap = _.groupBy(data.projectPersons, 'projectId');
		data.projectPersonByPersonMap = _.groupBy(data.projectPersons, 'personId');
		data.projectStatusMap = new Map(data.projectStatuses.map(projectStatus => [projectStatus.projectId, projectStatus]));
		data.projectLabelByProjectMap = _.groupBy(data.projectLabels, 'projectId');
		data.statusColumnMap = new Map(data.statusColumns.map(statusColumn => [statusColumn.id, statusColumn]));
		data.taskMap = new Map(data.tasks.map(task => [task.id, task]));
		data.personLabelByPersonMap = _.groupBy(data.personLabels, 'personId');
		data.personSkillsByPersonMap = _.groupBy(data.personSkills, 'personId');
		data.teamPersonByTeamMap = _.groupBy(data.teamPersons, 'teamId');
		data.teamsRelay = this.createRelayTeamDataStructure(data);
		data.parentTimeRegistrationMap = new Map();
		data.featureFlags = this.state.initData.featureFlags;
		for (const timeRegistration of data.timeRegistrations) {
			const id = timeRegistration.taskId || timeRegistration.projectId || timeRegistration.idleTimeId;
			const currentArray = data.parentTimeRegistrationMap.get(id) || [];
			currentArray.push(timeRegistration);
			data.parentTimeRegistrationMap.set(id, currentArray);
			timeRegistration.date = createCanvasTimelineDate(
				timeRegistration.year,
				timeRegistration.month,
				timeRegistration.day
			);
		}
		let projectTimelineProjectStatus = null;
		if (props.isProjectTimeline && props.match.params.projectId != null) {
			let project = data.projects.find(p => p.companyProjectId.toString() === props.match.params.projectId);
			if (project) {
				projectTimelineProjectStatus = project.status;
			}
		}

		this.setState(
			{
				viewer: data.viewer,
				data,
			},
			() => {
				this.entityRelevancyMap = this.getEntityRelevancyMap(data);

				const {groups, items} = this.getGroupsAndItemsFromProps(props, data, this.peopleEyeOptions);

				this.setInitialExpansion(groups);

				let filters;
				const filterString = `canvas-scheduling-filters-v4-people`;
				if (localStorage.getItem(filterString) === 'undefined') {
					localStorage.removeItem(filterString);
				}
				if (localStorage.getItem(filterString)) {
					filters = JSON.parse(localStorage.getItem(filterString));
				} else {
					filters = {
						person: {},
						task: {},
						project: {},
					};
				}

				const filterFunctions = getFilterFunctions(filters);

				if (data.company.isUsingProjectAllocation) {
					// if the  company.isUsingProjectAllocation ignore the task filters saved in the localStorage
					filters.task = {};
				}

				this.setState(
					{
						collapsableSectionGroups: this.getCollapsableSectionGroupsFromProps(props, data),
						dataLoaded: true,
						savingMutation: false,
						groups,
						items,
						filters,
						project: data.projects.find(project => project.companyProjectId.toString() === this.props.projectId),
						dependencies: data.dependencies,
						isShowingProjectTimelineSimulationMode: false,
						projectTimelineProjectStatus,
						peopleSchedulingDetailSelectorOptions: this.peopleEyeOptions,
						filterFunctions,
						allDataLoaded: loadAllData,
						allDataLoading: false,
						heatmapInitializedByPerson: new Map(),
					},
					() => {
						this.onTimelineRangeChange(this.timeline.startDate);
						if (loadAllData) {
							data.persons.forEach(person => {
								if (this.heatmapCache.get(person.id)) {
									this.heatmapCache.get(person.id).needsRecalculation = true;
								}
							});
							data.roles.forEach(role => {
								if (this.heatmapCache.get(role.id)) {
									this.heatmapCache.get(role.id).needsRecalculation = true;
								}
							});
							this.clearCompanyUtilizationCache();
						}
						this.filterItems();
						this.setState({items: this.state.items}, () =>
							dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false, isInitialLoad: true})
						);
						dispatch(EVENT_ID.PAGE_LOADED, 'people_scheduling_full');
						if (this.mutationResponse) {
							this.onSchedulingModalMutationSuccess(this.mutationResponse);
						}
					}
				);

				if (data.viewer.email.endsWith('forecastit.dk')) {
					const elem = document.createElement('div');
					elem.id = 'CompanyUtilCalculated';
					elem.style.cssText = 'position:absolute;visibility:hidden';
					elem.textContent = '';
					document.body.appendChild(elem);
				}
			}
		);
	}

	handleSocketNotify(dataList) {
		if (
			this.state.initData &&
			this.state.initData.featureFlags.some(flag => flag.key === 'use_push_on_people_scheduling')
		) {
			handleNotification(this, dataList);
		}
	}

	getData() {
		return this.state.data;
	}

	getFilterData() {
		return this.state.data ? this.state.data : this.state.lightWeightData;
	}

	getViewer() {
		return this.state.viewer;
	}

	setInitialExpansion(groups) {
		if (this.props.expansionMap && this.props.expansionMap.size) {
			const processGroup = group => {
				const shouldChangeGroup = (this.props.expansionMap.get(group.id) || false) !== group.expanded;
				if (shouldChangeGroup) {
					group.toggleExpansion();
				}

				if (group.groups) {
					for (const childGroup of group.groups) {
						if (!childGroup.parentGroup) {
							childGroup.parentGroup = group;
						}
						processGroup(childGroup);
					}
				}
			};
			for (const group of groups) {
				processGroup(group);
			}
		}
	}

	onGroupExpansionToggle(group) {
		//Store expansion status so that we can keep track of it when switching between tabs
		if (group && group.groupType !== GROUP_TYPE.PEOPLE_SCHEDULING_COMPANY_UTILIZATION) {
			this.props.expansionMap.set(group.id, group.expanded);
		}
	}

	onSavedFiltersUpdate(response) {
		const stateData = this.getFilterData();
		if (response.createFilter) {
			stateData.personFilters.push(response.createFilter.filter.node);
			this.setState({data: stateData});
		} else if (response.updateFilter) {
			this.setState({data: stateData});
		} else if (response.deleteFilter) {
			stateData.personFilters = stateData.personFilters.filter(
				filter => filter.id !== response.deleteFilter.deletedFilterId
			);
			this.setState({data: stateData});
		}
	}

	onClick(e) {
		if ((!e.target || e.target.id !== 'actions-btn') && this.state.showExpandedActionMenu) {
			this.hideExpandedActionMenu();
		}

		if (this.state.contextMenuX) {
			this.setState({contextMenuX: undefined, contextMenuY: undefined, contextMenuOptions: undefined});
		}
	}

	onForegroundContextMenu(e, mouseTargetData, canvasDate) {
		e.preventDefault();
		if (!mouseTargetData.itemData) return;
		const {item} = mouseTargetData.itemData;
		if (!item) return;

		// hide the tooltip
		this.setState({showDetailBox: false, hoverX: null, hoverY: null});

		if (item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK) {
			onTaskContextMenu(this, e, item, false);
		} else if (item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_PROJECT_ALLOCATION) {
			onAllocationContextMenu(this, e, item, canvasDate, false);
		}
	}

	onKeyPress(e) {
		if (!this.getData()) {
			return;
		}

		const isCalculationSwitchEnabled =
			this.getData().viewer.email &&
			typeof this.getData().viewer.email === 'string' &&
			this.getData().viewer.email.endsWith('@forecast.it') &&
			(this.getData().viewer.email.toLowerCase().includes('j') ||
				this.getData().viewer.email.toLowerCase().includes('n'));
		if (isCalculationSwitchEnabled && e.key === 'j') {
			this.isCalculationSwitched = !this.isCalculationSwitched;
			let isInActualMode =
				!this.getData().company.isUsingSchedulingPlanMode && !this.getData().company.isUsingProjectAllocation;
			if (this.isCalculationSwitched) {
				isInActualMode = !isInActualMode;
			}
			createToast({
				duration: 5000,
				message: isInActualMode ? 'Switched to actual calculation mode' : 'Switched to planned calculation mode',
			});
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
		}
	}

	onDetailSelectorChange(column) {
		if (column.name === 'company-utilization') {
			this.state.groups.find(group => group.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_COMPANY_UTILIZATION).filtered =
				!column.checked;
			requestAnimationFrame(() => {
				this.timeline.scrollToTop();
			});
		}
	}

	clearCompanyUtilizationCache() {
		for (const value of this.companyUtilizationCache.values()) {
			value.needsRecalculation = true;
		}

		this.cachedUnassignedTasksCount = undefined;

		for (const value of this.personGroupUtilizationCache.values()) {
			value.needsRecalculation = true;
		}
	}

	onSchedulingModalMutationSuccess(response) {
		const data = this.getData();
		if (!data) {
			this.mutationResponse = response;
			this.setState({savingMutation: true});
			return;
		}

		handlePeopleSchedulingMutation(this, response);
	}

	/*
	 * Returns a mapping from client ids to client objects
	 */
	getClientMap(data) {
		const clientIdMap = new Map();
		for (const client of data.clients) {
			clientIdMap.set(client.id, client);
		}
		return clientIdMap;
	}

	/*
	 * Returns four mappings:
	 *   * projectIdMap: from project id to project object
	 *   * projectsInConnection: a list of all project ids that are part of a connected project
	 *   * groupProjectsMap: from a connected project's id to a list of the projects in that connected project
	 *   * projectGroupIdMap: from connected project id to connected project object
	 */
	getProjectMap(data) {
		const groupProjectsMap = new Map();
		for (const projectGroup of data.projectGroups) {
			groupProjectsMap.set(projectGroup.id, []);
		}
		const projectIdMap = new Map();
		const projectsInConnection = [];
		for (const project of data.projects) {
			projectIdMap.set(project.id, project);
			if (project.isInProjectGroup) {
				projectsInConnection.push(project.id);
				//group won't be in the map if person is collaborator and not assigned to the group
				if (groupProjectsMap.has(project.projectGroupId)) {
					groupProjectsMap.get(project.projectGroupId).push(project);
				}
			}
		}
		const projectGroupIdMap = new Map();
		for (const projectGroup of data.projectGroups) {
			projectGroupIdMap.set(projectGroup.id, projectGroup);
		}
		return {
			projectIdMap,
			projectsInConnection,
			groupProjectsMap,
			projectGroupIdMap,
		};
	}

	/*
	 * Returns two mappings:
	 *   * projectPersonMap: from person id to a list of project ids that the person is involved in
	 *   * projectGroupPersonMap: from person id to a list of connected project ids that the person is involved in
	 */
	getProjectPersonMap(data, projectsInConnection, projectIdMap) {
		const projectPersonMap = new Map();
		const projectGroupPersonMap = new Map();
		for (const projectPerson of data.projectPersons) {
			const {personId, projectId} = projectPerson;
			if (!projectPersonMap.get(personId)) {
				projectPersonMap.set(personId, []);
			}
			if (!projectGroupPersonMap.get(personId)) {
				projectGroupPersonMap.set(personId, []);
			}
			if (projectsInConnection.includes(projectId)) {
				if (projectIdMap.get(projectId)) {
					const {projectGroupId} = projectIdMap.get(projectId);
					if (!projectGroupPersonMap.get(personId).includes(projectGroupId)) {
						projectGroupPersonMap.get(personId).push(projectGroupId);
					}
				}
			} else {
				projectPersonMap.get(personId).push(projectId);
			}
		}
		return {projectPersonMap, projectGroupPersonMap};
	}

	/*
	 * Returns a map from person id to all allocations applying to that person
	 */
	getPersonAllocationMap(data) {
		const personAllocationMap = new Map();
		for (const allocation of data.allocations) {
			const {personId} = allocation;
			if (!personAllocationMap.get(personId)) {
				personAllocationMap.set(personId, []);
			}
			personAllocationMap.get(personId).push(allocation);
		}
		return {personAllocationMap};
	}

	/*
	 * Preprocesses the data from props. Each returned map is described by the
	 * function that returns it.
	 */
	preprocessData(data) {
		const clientIdMap = this.getClientMap(data);
		const {projectIdMap, projectsInConnection, groupProjectsMap, projectGroupIdMap} = this.getProjectMap(data);
		const {projectPersonMap, projectGroupPersonMap} = this.getProjectPersonMap(data, projectsInConnection, projectIdMap);
		const {personAllocationMap} = this.getPersonAllocationMap(data);
		return {
			clientIdMap,
			projectIdMap,
			projectsInConnection,
			projectPersonMap,
			projectGroupPersonMap,
			projectGroupIdMap,
			groupProjectsMap,
			personAllocationMap,
		};
	}

	viewProject(isGroup, id) {
		const link = isGroup ? projectGroupUrl(id) : projectUrl(id);
		const lastViewedPage =
			(isGroup
				? localStorage.getItem('project-group-section-last-viewed')
				: localStorage.getItem('project-section-last-viewed')) || 'workflow';
		this.props.history.push(`${link}/${lastViewedPage}`);
	}

	addPersonToProject(person) {
		showModal({
			type: MODAL_TYPE.ADD_PERSON_TO_PROJECT_MODAL,
			personId: person.id,
			projectGroups: this.state.data.projectGroups,
			projects: this.state.data.projects,
			projectPersons: this.state.data.projectPersons,
			actualPersonId: this.state.data.viewer.actualPersonId,
		});
	}

	isProjectGroupingDisabled() {
		return !this.state.peopleSchedulingDetailSelectorOptions
			.find(option => option.name === 'show-heatmap')
			.nestedOptions.find(option => option.name === 'show-projects').checked;
	}

	isHeatMapDisabled() {
		return !this.state.peopleSchedulingDetailSelectorOptions.find(option => option.name === 'show-heatmap').checked;
	}

	showExpandedActionMenu() {
		this.setState({
			expandedActionMenuY: this.state.collapsedActionMenuY,
			expandedActionMenuData: this.state.collapsedActionMenuData,
			showExpandedActionMenu: true,
			expandedActionMenuType: this.state.actionMenuType,
		});
	}

	hideExpandedActionMenu() {
		this.setState({
			showExpandedActionMenu: false,
			expandedActionMenuType: null,
		});
	}

	onPersonGroupMouseEnter(person, canvasData) {
		const offsetY = hasFeatureFlag("timeline_group_section_restyling")
			? canvasData.y + (canvasData.height / 2) - (GROUP_SECTION_ACTION_BUTTON_SIZE / 2)
			: canvasData.y + 10;

		this.setState({
			showCollapsedActionMenu:
				hasFeatureFlag('project_person_management_in_schedule') && hasPermission(PERMISSION_TYPE.PROJECT_PERSON_CREATE),
			collapsedActionMenuY: offsetY,
			collapsedActionMenuData: {person},
			actionMenuType: SCHEDULING_ACTION_MENU_TYPE.PERSON,
		});
	}

	onPersonGroupMouseLeave() {
		this.setState({showCollapsedActionMenu: false});
	}

	onProjectGroupMouseEnter(project, person, canvasData) {
		const offsetY = hasFeatureFlag("timeline_group_section_restyling")
			? canvasData.y + (canvasData.height / 2) - (GROUP_SECTION_ACTION_BUTTON_SIZE / 2)
			: canvasData.y + 6;

		this.setState({
			showCollapsedActionMenu: true,
			collapsedActionMenuY: offsetY,
			collapsedActionMenuData: {project, person},
			actionMenuType: SCHEDULING_ACTION_MENU_TYPE.PROJECT,
		});
	}

	onProjectGroupMouseLeave() {
		this.setState({showCollapsedActionMenu: false});
	}

	onTaskMouseEnter(task, data, e) {
		this.setState({
			hoverX: e.clientX,
			hoverY: e.clientY,
			showDetailBox: false,
		});
		setTimeout(() => {
			this.setState({
				detailBoxLeft: data.x,
				detailBoxY: data.y,
				detailBoxTop: data.y - 2,
				detailBoxData: {task, allocation: null},
			});
			if (this.state.hoverX === e.clientX && this.state.hoverY === e.clientY) {
				this.setState({showDetailBox: true, detailBoxX: e.clientX});
			}
		}, 200);
	}

	onTaskMouseLeave() {
		this.setState({showDetailBox: false, hoverX: null, hoverY: null, detailBoxData: null});
	}

	onTaskMouseMove(data, e) {
		this.setState({
			hoverX: e.clientX,
			hoverY: e.clientY,
			showDetailBox: false,
		});
		setTimeout(() => {
			if (this.state.hoverX === e.clientX && this.state.hoverY === e.clientY && this.state.detailBoxData) {
				this.setState({showDetailBox: true, detailBoxX: e.clientX});
			}
		}, 200);
	}

	onTaskGroupArrowClick(isPrevious) {
		const {hoveredTaskGroupId} = this.state;
		if (!hoveredTaskGroupId) return;

		const isPersonTasksGroup = hoveredTaskGroupId.includes('-alltask');
		const isPersonAllocationsGroup = hoveredTaskGroupId.includes('-allocation');

		let placeholderGroupIds = [];
		if (isPersonTasksGroup || isPersonAllocationsGroup) {
			const personGroup = getPersonGroups(this.state.groups).find(group => group.id === hoveredTaskGroupId.split('-')[0]);
			placeholderGroupIds = personGroup.groups.find(group => group.id === hoveredTaskGroupId).groupIds;
		}

		const timeline = this.timeline;
		const screenCenterDate = timeline.startDate + timeline.state.canvasWidth / timeline.pixelsPerDay / 2;
		//Make minimum scroll distance 3 days because it makes little sense to fire the animation just to scroll by a few pixels
		const items = this.state.items.filter(
			item =>
				!item.filtered &&
				// removed conditions to make this work for the project allocations and task allocations too, if there is a good reason for having them we need to add logic for handling project allocations too
				// item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK &&
				// !item.data.task.done &&
				(isPersonTasksGroup || isPersonAllocationsGroup
					? placeholderGroupIds.includes(item.groupId)
					: item.groupId === hoveredTaskGroupId) &&
				(isPrevious ? item.startDate - screenCenterDate < -2 : item.startDate - screenCenterDate > 2)
		);

		if (!items.length) return; //Already scrolled to furthermost task
		//Sort by startDate descending, we want to scroll to the item that is the closest to the center in the scrolling direction
		items.sort((a, b) => {
			if (a.startDate < b.startDate) return isPrevious ? 1 : -1;
			if (b.startDate < a.startDate) return isPrevious ? -1 : 1;
			return 0;
		});
		timeline.scrollToCanvasDate(items[0].startDate);
		tracking.trackEvent('Scheduling left/right arrow navigation used');
	}

	onTaskGroupMouseEnter(hoveredTaskGroupId, isInCollapsableSection, isPersonTasksGroup, isPersonAllocationsGroup, data) {
		if (isPersonTasksGroup && !this.isProjectGroupingDisabled()) return; //Pladeholder group with project grouping on
		const showArrowClickableArea = this.state.items.some(
			item =>
				item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK &&
				(isPersonTasksGroup
					? hoveredTaskGroupId === `${item.groupId.split('-')[0]}-alltask`
					: isPersonAllocationsGroup
					? hoveredTaskGroupId === `${item.groupId.split('-')[0]}-allocation`
					: item.groupId === hoveredTaskGroupId) &&
				!item.data.task.done
		);

		this.setState({
			showArrowClickableArea,
			arrowClickableAreaY: data.y + (isInCollapsableSection ? 7 : 0),
			hoveredTaskGroupId,
		});
	}

	onTaskGroupMouseLeave() {
		this.setState({showArrowClickableArea: false, arrowClickableAreaY: null, hoveredTaskGroupId: null});
	}

	onExpandPersonGroups(expanded) {
		for (const group of this.state.groups) {
			if (group.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PERSON_GROUP) {
				group.setExpanded(expanded);
				this.onGroupExpansionToggle(group);
			}
		}
	}
	/*
	 * The main function. This processes the props and returns the groups and items.
	 */
	getGroupsAndItemsFromProps(props, data, eyeOptions) {
		const roleGroupsByRoleId = new Map();
		const firstLevelGroups = [];
		const items = [];
		const {formatMessage} = this.props.intl;
		const noGrouping = this.state.peopleSchedulingOptions.groupBy === GROUP_BY.NONE;
		const groupByRole = this.state.peopleSchedulingOptions.groupBy === GROUP_BY.ROLE;
		const groupByDepartment = this.state.peopleSchedulingOptions.groupBy === GROUP_BY.DEPARTMENT;

		const persons = data.persons.sort((a, b) => {
			const aName = `${a.firstName || ''} ${a.lastName || ''}`.toLowerCase();
			const bName = `${b.firstName || ''} ${b.lastName || ''}`.toLowerCase();
			if (aName < bName) return -1;
			if (bName < aName) return 1;
			return 0;
		});

		const {projectIdMap, projectPersonMap, projectGroupIdMap, projectGroupPersonMap, personAllocationMap} =
			this.preprocessData(data);

		if (hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS)) {
			firstLevelGroups.push(
				new CompanyUtilizationGroup({
					id: 'company-utilization',
					filtered: !eyeOptions.find(option => option.name === 'company-utilization').checked,
					composeItems: this.composeCompanyUtilizationRow.bind(this),
					formatMessage,
					preventExpansion: noGrouping,
					onExpand: this.onExpandPersonGroups.bind(this),
				})
			);
		}
		for (const person of persons) {
			//Only show the viewer if a person is a collaborator
			if (!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS) && person.id !== data.viewer.actualPersonId) continue;
			if (person.clientId || !person.active) continue; //Do not show client users and inactive people
			const projectIds = projectPersonMap.get(person.id) || [];
			const projectGroupIds = projectGroupPersonMap.get(person.id) || [];
			const projectGroups = [];
			const hasCreateItemPermission =
				!data.company.isUsingProjectAllocation || hasPermission(PERMISSION_TYPE.ALLOCATION_CREATE);

			for (const projectId of projectIds) {
				const project = projectIdMap.get(projectId);
				if (!project || project.isInProjectGroup) {
					continue;
				} else {
					const projectGroup = this.getNewProjectGroup(person, project);
					projectGroups.push(projectGroup);
				}
			}

			for (const projectGroupId of projectGroupIds) {
				const projectGroup = projectGroupIdMap.get(projectGroupId);
				const firstProject = data.projects.find(project => project.projectGroupId === projectGroupId);
				const isDisabled =
					!hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL) &&
					!data.projectPersons.find(
						projectPerson =>
							projectPerson.personId === data.viewer.actualPersonId && projectPerson.projectId === firstProject.id
					);
				const {estimationUnit} = firstProject;
				const canCreateItems =
					!isDisabled &&
					hasCreateItemPermission &&
					!firstProject.isJiraProject &&
					data.projects
						.filter(project => project.projectGroupId === projectGroupId)
						.some(project => project.status !== 'HALTED' && project.status !== 'DONE');

				projectGroups.push(
					new ProjectGroup({
						id: `${person.id}-${projectGroup.id}`,
						personId: person.id,
						companyProjectGroupId: projectGroup.companyProjectGroupId,
						name: `${projectGroup.name}`,
						color: `${projectGroup.color}`,
						status: ``, // TODO ?
						isConnectedProject: true,
						isProjectTimeline: props.isProjectTimeline,
						estimationUnit,
						isDisabled,
						preventExpansion: true,
						hideIfEmpty: true,
						hideCondition: () => {
							return this.isProjectGroupingDisabled();
						},
						onMouseEnter: isDisabled ? undefined : this.onProjectGroupMouseEnter.bind(this, projectGroup, person),
						onMouseLeave: isDisabled ? undefined : this.onProjectGroupMouseLeave.bind(this, projectGroup),
						onItemCreate: !canCreateItems
							? undefined
							: (startDate, endDate) => {
									const momentStartDate = getMomentFromCanvasTimelineDate(startDate);
									const momentEndDate = getMomentFromCanvasTimelineDate(endDate);

									showModal({
										type: MODAL_TYPE.CANVAS_CREATE,
										projectGroups: this.getData().projectGroups,
										projects: this.getData().projects,
										idleTimes: this.getData().idleTimes,
										projectPersons: this.getData().projectPersons,
										actualPersonId: this.getData().viewer.actualPersonId,
										persons: this.getData().persons,
										selectedPersonId: person.id,
										selectedProject: projectGroup,
										milestones: this.getData().phases,
										company: this.getData().company,
										holidayCalendars: this.getData().holidayCalendars,
										holidayCalendarEntries: this.getData().holidayCalendarEntries,
										allocation: {
											personId: person.id,
											startDay: momentStartDate.date(),
											startMonth: momentStartDate.month() + 1,
											startYear: momentStartDate.year(),
											endDay: momentEndDate.date(),
											endMonth: momentEndDate.month() + 1,
											endYear: momentEndDate.year(),
											monday: person.monday,
											tuesday: person.tuesday,
											wednesday: person.wednesday,
											thursday: person.thursday,
											friday: person.friday,
											saturday: person.saturday,
											sunday: person.sunday,
											registerTime: false,
										},
										roles: this.getData().roles,
										teams: this.getData().teams,
										teamPersons: this.getData().teamPersons,
										removeLowHigh: this.getData().viewer.availableFeatureFlags.some(
											flag => flag.key === 'remove_low_high'
										),
									});
							  },
					})
				);
			}
			projectGroups.push(
				new NonProjectTimeGroup({
					id: person.id + '-2',
					personId: person.id,
					name: formatMessage({id: 'common.non-project-time'}),
					hideIfEmpty: true,
					hideCondition: () => {
						return this.isProjectGroupingDisabled();
					},
					onItemCreate: !hasPermission(PERMISSION_TYPE.ALLOCATION_CREATE)
						? undefined
						: (startDate, endDate) => {
								const momentStartDate = getMomentFromCanvasTimelineDate(startDate);
								const momentEndDate = getMomentFromCanvasTimelineDate(endDate);
								showModal({
									type: MODAL_TYPE.CANVAS_CREATE,
									projectGroups: this.getData().projectGroups,
									projects: this.getData().projects,
									idleTimes: this.getData().idleTimes,
									projectPersons: this.getData().projectPersons,
									actualPersonId: this.getData().viewer.actualPersonId,
									persons: this.getData().persons,
									selectedPersonId: person.id,
									milestones: this.getData().phases,
									company: this.getData().company,
									holidayCalendars: this.getData().holidayCalendars,
									holidayCalendarEntries: this.getData().holidayCalendarEntries,
									allocation: {
										personId: person.id,
										startDay: momentStartDate.date(),
										startMonth: momentStartDate.month() + 1,
										startYear: momentStartDate.year(),
										endDay: momentEndDate.date(),
										endMonth: momentEndDate.month() + 1,
										endYear: momentEndDate.year(),
										monday: person.monday,
										tuesday: person.tuesday,
										wednesday: person.wednesday,
										thursday: person.thursday,
										friday: person.friday,
										saturday: person.saturday,
										sunday: person.sunday,
										registerTime: false,
									},
									roles: this.getData().roles,
									teams: this.getData().teams,
									teamPersons: this.getData().teamPersons,
									isCreatingInNonProjectTime: true,
									removeLowHigh: this.getData().viewer.availableFeatureFlags.some(
										flag => flag.key === 'remove_low_high'
									),
								});
								tracking.trackEvent('Create Allocation from Timeline');
						  },
				})
			);

			// Allocation group used when not grouping by project, shows all project and non-project allocations for person
			projectGroups.push(
				new PersonAllocationsGroup({
					id: `${person.id}-allocation`,
					personId: person.id,
					groupIds: data.projects
						.map(project => `${person.id}-${project.id}`)
						.concat(data.projectGroups.map(projectGroup => `${person.id}-${projectGroup.id}`))
						.concat([`${person.id}-2`]),
					name: formatMessage({id: 'scheduling.allocations_and_task'}),
					hideCondition: () => {
						return !this.isProjectGroupingDisabled();
					},
					onMouseEnter: this.onTaskGroupMouseEnter.bind(this, `${person.id}-allocation`, false, false, true),
					onMouseLeave: this.onTaskGroupMouseLeave.bind(this),
					isHeatMapDisabled: this.isHeatMapDisabled.bind(this),
					onItemCreate: !hasCreateItemPermission
						? undefined
						: (startDate, endDate) => {
								const momentStartDate = getMomentFromCanvasTimelineDate(startDate);
								const momentEndDate = getMomentFromCanvasTimelineDate(endDate);
								showModal({
									type: MODAL_TYPE.CANVAS_CREATE,
									projectGroups: this.getData().projectGroups,
									projects: this.getData().projects,
									idleTimes: this.getData().idleTimes,
									projectPersons: this.getData().projectPersons,
									actualPersonId: this.getData().viewer.actualPersonId,
									persons: this.getData().persons,
									selectedPersonId: person.id,
									milestones: this.getData().phases,
									company: this.getData().company,
									holidayCalendars: this.getData().holidayCalendars,
									holidayCalendarEntries: this.getData().holidayCalendarEntries,
									allocation: {
										personId: person.id,
										startDay: momentStartDate.date(),
										startMonth: momentStartDate.month() + 1,
										startYear: momentStartDate.year(),
										endDay: momentEndDate.date(),
										endMonth: momentEndDate.month() + 1,
										endYear: momentEndDate.year(),
										monday: person.monday,
										tuesday: person.tuesday,
										wednesday: person.wednesday,
										thursday: person.thursday,
										friday: person.friday,
										saturday: person.saturday,
										sunday: person.sunday,
										registerTime: false,
									},
									roles: this.getData().roles,
									teams: this.getData().teams,
									teamPersons: this.getData().teamPersons,
									removeLowHigh: this.getData().viewer.availableFeatureFlags.some(
										flag => flag.key === 'remove_low_high'
									),
								});
								tracking.trackEvent('Create Allocation from Timeline');
						  },
				})
			);

			projectGroups.push(
				new PlaceholderGroup({
					id: person.id + '-3',
					name: formatMessage({id: 'scheduling.no_current_projects'}),
					showOnlyIfNoSiblingsVisible: true,
					personId: person.id,
					hideCondition: () => {
						return (
							this.isProjectGroupingDisabled() &&
							!this.state.peopleSchedulingOptions.showTasks &&
							!this.state.peopleSchedulingOptions.showAllocations
						);
					},
					onItemCreate: !hasCreateItemPermission
						? undefined
						: (startDate, endDate) => {
								const momentStartDate = getMomentFromCanvasTimelineDate(startDate);
								const momentEndDate = getMomentFromCanvasTimelineDate(endDate);

								showModal({
									type: MODAL_TYPE.CANVAS_CREATE,
									projectGroups: this.getData().projectGroups,
									projects: this.getData().projects,
									idleTimes: this.getData().idleTimes,
									projectPersons: this.getData().projectPersons,
									actualPersonId: this.getData().viewer.actualPersonId,
									persons: this.getData().persons,
									selectedPersonId: person.id,
									milestones: this.getData().phases,
									company: this.getData().company,
									holidayCalendars: this.getData().holidayCalendars,
									holidayCalendarEntries: this.getData().holidayCalendarEntries,
									allocation: {
										personId: person.id,
										startDay: momentStartDate.date(),
										startMonth: momentStartDate.month() + 1,
										startYear: momentStartDate.year(),
										endDay: momentEndDate.date(),
										endMonth: momentEndDate.month() + 1,
										endYear: momentEndDate.year(),
										monday: person.monday,
										tuesday: person.tuesday,
										wednesday: person.wednesday,
										thursday: person.thursday,
										friday: person.friday,
										saturday: person.saturday,
										sunday: person.sunday,
										registerTime: false,
									},
									roles: this.getData().roles,
									teams: this.getData().teams,
									teamPersons: this.getData().teamPersons,
									removeLowHigh: this.getData().viewer.availableFeatureFlags.some(
										flag => flag.key === 'remove_low_high'
									),
								});
						  },
				})
			);

			const {roles} = data;
			let roleName = '';
			if (person.roleId) {
				const role = roles.find(role => role.id === person.roleId);
				if (role) {
					roleName = role.name;
				}
			}

			const {departments} = data;
			let departmentName = '';
			if (person.departmentId) {
				const department = departments.find(department => department.id === person.departmentId);
				if (department) {
					departmentName = department.name;
				}
			}
			const labelIds = data.personLabels
				.filter(personLabel => personLabel.personId === person.id)
				.map(personLabel => personLabel.labelId);

			const skillIds = data.personSkills
				.filter(personSkill => personSkill.personId === person.id)
				.map(personSkill => personSkill.skillId);

			let groupIds = [`${person.id}-1`, `${person.id}-2`]
				.concat(projectIds.map(projectId => `${person.id}-${projectId}`))
				.concat(projectIds.map(projectId => `${person.id}-${projectId}-task`))
				.concat(projectGroupIds.map(projectGroupId => `${person.id}-${projectGroupId}`))
				.concat(projectGroupIds.map(projectGroupId => `${person.id}-${projectGroupId}-task`));

			const personGroup = new PersonGroup({
				id: person.id,
				groupIds,
				name: `${person.firstName == null ? '' : person.firstName} ${person.lastName == null ? '' : person.lastName}`,
				startDate: person.startDate,
				endDate: person.endDate,
				roleId: person.roleId || null,
				roleName,
				profilePictureId: person.profilePictureId,
				profilePictureDefaultId: person.profilePictureDefaultId,
				groups: projectGroups,
				composeItems: this.composePersonHeatMapRow.bind(this),
				filterGroup: this.filterPersonGroupV4.bind(this),
				labelIds,
				skillIds,
				monday: person.monday,
				tuesday: person.tuesday,
				wednesday: person.wednesday,
				thursday: person.thursday,
				friday: person.friday,
				saturday: person.saturday,
				sunday: person.sunday,
				departmentId: person.departmentId,
				holidayCalendarId: person.holidayCalendarId,
				permissionLevel: person.userType,
				onPersonImageLoad: this.onPersonImageLoad.bind(this),
				isHeatMapDisabled: this.isHeatMapDisabled.bind(this),
				onMouseEnter: this.onPersonGroupMouseEnter.bind(this, person),
				onMouseLeave: this.onPersonGroupMouseLeave.bind(this, person),
				onItemCreate: !hasCreateItemPermission
					? undefined
					: (startDate, endDate) => {
							const momentStartDate = getMomentFromCanvasTimelineDate(startDate);
							const momentEndDate = getMomentFromCanvasTimelineDate(endDate);
							showModal({
								type: MODAL_TYPE.CANVAS_CREATE,
								projectGroups: this.getData().projectGroups,
								projects: this.getData().projects,
								idleTimes: this.getData().idleTimes,
								projectPersons: this.getData().projectPersons,
								actualPersonId: this.getData().viewer.actualPersonId,
								persons: this.getData().persons,
								selectedPersonId: person.id,
								milestones: this.getData().phases,
								company: this.getData().company,
								holidayCalendars: this.getData().holidayCalendars,
								holidayCalendarEntries: this.getData().holidayCalendarEntries,
								allocation: {
									personId: person.id,
									startDay: momentStartDate.date(),
									startMonth: momentStartDate.month() + 1,
									startYear: momentStartDate.year(),
									endDay: momentEndDate.date(),
									endMonth: momentEndDate.month() + 1,
									endYear: momentEndDate.year(),
									monday: person.monday,
									tuesday: person.tuesday,
									wednesday: person.wednesday,
									thursday: person.thursday,
									friday: person.friday,
									saturday: person.saturday,
									sunday: person.sunday,
									registerTime: false,
								},
								roles: this.getData().roles,
								teams: this.getData().teams,
								teamPersons: this.getData().teamPersons,
								removeLowHigh: this.getData().viewer.availableFeatureFlags.some(
									flag => flag.key === 'remove_low_high'
								),
							});
							tracking.trackEvent('Create Allocation from Timeline');
					  },
			});
			if (groupByRole || groupByDepartment) {
				personGroup.marginX = 16;
				for (const child of personGroup.groups) {
					child.marginX = 32;
				}

				const groupId = groupByRole
					? person.roleId
						? person.roleId
						: 'no-role'
					: person.departmentId
					? person.departmentId
					: 'no-department';
				const groupName = groupByRole
					? roleName
						? roleName
						: 'No Role'
					: departmentName
					? departmentName
					: 'No Department';

				if (!roleGroupsByRoleId.get(groupId)) {
					const personRoleGroup = new PersonGroupingGroup({
						id: groupId,
						name: groupName,
						groups: [personGroup],
						composeItems: this.composePersonGroupUtilizationRow.bind(this),
						filterGroup: this.filterPersonGroupingGroupV4.bind(this),
					});
					roleGroupsByRoleId.set(groupId, personRoleGroup);
				} else {
					roleGroupsByRoleId.get(groupId).groups.push(personGroup);
				}
			} else {
				firstLevelGroups.push(personGroup);
			}

			//Creating allocation items
			const allocations = personAllocationMap.get(person.id);

			if (allocations) {
				for (const allocation of allocations) {
					const projectAllocationItem = new ProjectAllocationItem(this, allocation);
					if (projectAllocationItem.isValid()) {
						items.push(projectAllocationItem);
					}
				}
			}
		}

		roleGroupsByRoleId.forEach(roleGroup => {
			firstLevelGroups.push(roleGroup);
		});

		firstLevelGroups.sort((a, b) => {
			const aName = (a.data.name || '').toLowerCase();
			const bName = (b.data.name || '').toLowerCase();
			if (aName < bName) {
				return -1;
			}
			if (bName < aName) {
				return 1;
			}
			return 0;
		});

		return {groups: firstLevelGroups, items};
	}

	getEntityRelevancyMap(data) {
		let lowestStep = null;
		let highestStep = 1;
		const relevancyMap = new Map();

		const addToRelevancyMap = (date, entity) => {
			if (!date) return;
			const step = this.getDateRelevancyStep(date);
			const stepArray = relevancyMap.get(step) || [];
			stepArray.push(entity);
			relevancyMap.set(step, stepArray);
			if (step > highestStep) {
				highestStep = step;
			}
			if (lowestStep === null || step < lowestStep) {
				lowestStep = step;
			}
		};

		for (const task of data.tasks) {
			let date = createCanvasTimelineDate(task.deadlineYear, task.deadlineMonth, task.deadlineDay);
			addToRelevancyMap(date, task);
		}
		this.lowestItemGeneratorStep = lowestStep;
		this.highestItemGeneratorStep = highestStep;
		return relevancyMap;
	}

	*itemCreationGenerator() {
		//Currently supports tasks - these are the relevant entities
		let step = this.highestItemGeneratorStep;
		const data = this.getData();
		if (!data) {
			yield false;
		} else {
			const {projectIdMap} = this.getProjectMap(data);
			const {todayDate, items} = this.state;
			while (step >= this.lowestItemGeneratorStep || 0) {
				this.currentItemCreationGeneratorStep = step;
				const relevantEntities = this.entityRelevancyMap.get(step) || [];
				for (const entity of relevantEntities) {
					const task = entity;
					if (!task.approved) continue;
					const startDate = createCanvasTimelineDate(task.startYear, task.startMonth, task.startDay);
					const endDate = createCanvasTimelineDate(task.deadlineYear, task.deadlineMonth, task.deadlineDay);
					if (Array.isArray(task.assignedPersons)) {
						for (const assignedPersonId of task.assignedPersons) {
							// if no dates create each time reg on task as separate item else include in task item
							if (areItemDatesValid(startDate, endDate)) {
								const taskItemData = this.composeTaskItem(task, assignedPersonId, todayDate);
								if (!taskItemData) continue;
								const taskItem = new TaskItem(taskItemData);

								items.push(taskItem);
							}
						}
					}
					//if no ppl assigned add item to the appropriate unassigned tasks role group
					if (!task.assignedPersons || task.assignedPersons.length === 0) {
						const taskProject = projectIdMap.get(task.projectId);
						if (
							task.startYear !== undefined &&
							task.startYear !== null &&
							task.deadlineYear !== undefined &&
							task.deadlineYear !== null &&
							!task.done &&
							![PROJECT_STATUS.HALTED, PROJECT_STATUS.DONE].includes(taskProject.status) &&
							(hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL) ||
								data.projectPersons.find(
									projectPerson =>
										projectPerson.personId === data.viewer.actualPersonId &&
										projectPerson.projectId === task.projectId
								))
						) {
							const taskItemData = this.composeTaskItem(task, null, todayDate);
							if (!taskItemData) continue;
							const taskItem = new TaskItem(taskItemData);
							items.push(taskItem);
						}
					}
				}
				step--;
				yield true;
			}
		}
	}

	getTaskAssignedPersonsMap() {
		const taskAssignedPersonsMap = new Map();
		this.getData().tasks.forEach(task => {
			taskAssignedPersonsMap.set(task.id, task.assignedPersons);
		});
		return taskAssignedPersonsMap;
	}

	composeTaskItem(task, personId, todayDate, enforcedTaskStartDate, enforcedTaskEndDate) {
		const taskStartDate = enforcedTaskStartDate || createCanvasTimelineDate(task.startYear, task.startMonth, task.startDay);
		const taskEndDate =
			enforcedTaskEndDate || createCanvasTimelineDate(task.deadlineYear, task.deadlineMonth, task.deadlineDay);
		let startDate = taskStartDate;
		let endDate = taskEndDate;
		if (!areItemDatesValid(startDate, endDate)) return null;
		const person = this.getData().persons.find(person => person.id === personId);
		if (!person) {
			personId = null;
		}
		let taskFragmentArray = [];
		const taskDayCount = endDate - startDate + 1;
		taskFragmentArray.push({
			isTask: true,
			position: 0,
			length: taskDayCount,
		});

		const taskProject = this.getData().projects.find(project => project.id === task.projectId);
		const isDoneOrHalted = ['DONE', 'HALTED'].includes(taskProject.status);

		//taskDayFragmentArray contains data of the "actual task" part of the whole item, not including time registrations outside and connecting lines
		const taskDayFragmentArray = [];
		for (let i = 0; i < taskDayCount; i++) {
			taskDayFragmentArray.push({isFilled: false}); //Fill the array with as many elements as there are days in a task
		}
		//Figure out which parts of the task should be fully colored and which should not
		//If the task is done or completely in the past, it will always be completely colored
		//If there is no personId, the task is in unassigned section and will also be completely colored
		if (!personId || task.done || endDate < todayDate) {
			for (const fragment of taskDayFragmentArray) {
				fragment.isFilled = true;
			}
		} else {
			//If the task is completely or partially in the future, only parts that are in the past or have time registrations will be colored
			//Notice: pastDayCount will be a negative number and not 0 if the task is completely in the future, does not matter for current calculations so not accounting for it
			const pastDayCount = (todayDate < taskEndDate ? todayDate : taskEndDate) - taskStartDate;
			for (let i = 0; i < pastDayCount; i++) {
				taskDayFragmentArray[i].isFilled = true;
			}
		}

		//Put all time registrations that are within the task dates into the array
		for (const fragment of taskFragmentArray) {
			//If the time registration is during the task, put it into the array
			if (fragment.isTimeRegistration && fragment.position >= 0 && fragment.position < taskDayCount) {
				taskDayFragmentArray[fragment.position].minutesRegistered = fragment.minutesRegistered || 0;
				taskDayFragmentArray[fragment.position].isFilled = true;
			}
		}
		//Remove time registrations which are within the task dates from fragment array since they will not be rendered as a separate block
		taskFragmentArray = taskFragmentArray.filter(fragment => {
			return fragment.isTask || fragment.position < 0 || fragment.position > taskDayCount - 1;
		});
		//Sort fragments by date
		taskFragmentArray.sort((a, b) => {
			if (a.position > b.position) return 1;
			if (b.position > a.position) return -1;
			return 0;
		});
		//If there are gaps between blocks, add connecting lines
		const connectingLineArray = [];
		for (let i = 0; i < taskFragmentArray.length - 1; i++) {
			const spaceDayCount =
				taskFragmentArray[i + 1].position - (taskFragmentArray[i].position + taskFragmentArray[i].length);
			if (spaceDayCount) {
				connectingLineArray.push({
					isConnectingLine: true,
					position: taskFragmentArray[i].position + taskFragmentArray[i].length,
					length: spaceDayCount,
				});
			}
		}
		taskFragmentArray = taskFragmentArray.concat(connectingLineArray);
		//The lines are added at the end of the array so need to sort by date again
		taskFragmentArray.sort((a, b) => {
			if (a.position > b.position) return 1;
			if (b.position > a.position) return -1;
			return 0;
		});
		//Combine time registrations outside of the task that are next to eachother into one block
		for (let i = 0; i < taskFragmentArray.length - 1; i++) {
			const fragment = taskFragmentArray[i];
			if (!fragment.isTimeRegistration) continue;
			let nextIndex = i + 1;
			while (nextIndex < taskFragmentArray.length) {
				const nextFragment = taskFragmentArray[nextIndex];
				i++;
				nextIndex++;
				if (nextFragment.isTimeRegistration && nextFragment.position === fragment.position + fragment.length) {
					fragment.length++;
					fragment.minutesRegistered += nextFragment.minutesRegistered;
					nextFragment.shouldBeDeleted = true;
				} else {
					break;
				}
			}
		}
		taskFragmentArray = taskFragmentArray.filter(fragment => {
			return !fragment.shouldBeDeleted;
		});
		//Only the actual task part of the whole (task + time registrations) item should be draggable, calculate the start and end of that area
		const totalItemDayCount = endDate - startDate + 1;
		const taskStartOffset = taskStartDate - startDate;
		const draggableArea = {
			start: taskStartOffset / totalItemDayCount,
			end: (taskStartOffset + taskDayCount) / totalItemDayCount,
		};

		return {
			// this groupId is used by the canvasTimeline to handle the placement of the item in a group
			groupId: personId
				? // isUsingNewDesign used for drawing the tasks allocation on the same line as project allocation
				  `${personId}-${taskProject.isInProjectGroup ? taskProject.projectGroupId : task.projectId}`
				: `${task.roleId ? task.roleId : 'no-role'}unassignedtask`,
			color: task.done ? '#00cc66' : taskProject.projectColor,
			isHourEstimated: taskProject.estimationUnit === ESTIMATION_UNIT.HOURS,
			minutesPerEstimationPoint: taskProject.minutesPerEstimationPoint,
			startDate,
			endDate,
			taskFragmentArray,
			taskDayFragmentArray,
			task,
			draggableArea,
			taskStartDate,
			taskEndDate,
			intl: this.props.intl,
			parentId: taskProject.isInProjectGroup ? taskProject.projectGroupId : task.projectId,
			draggableType: isDoneOrHalted ? undefined : DRAGGABLE_TYPE.DATE_AND_GROUP,
			onClick: () => {
				this.props.showTaskModal(task.companyTaskId, this.props.history);
			},
			onMouseEnter: this.onTaskMouseEnter.bind(this, task),
			onMouseLeave: this.onTaskMouseLeave.bind(this),
			onMouseMove: this.onTaskMouseMove.bind(this),
			onMoveAttempt: isDoneOrHalted ? this.onDoneOrHaltedMoveAttempt.bind(this) : undefined,
			onMoveStart: this.onTaskMoveStart.bind(this),
			onMoving: this.onTaskMoving.bind(this),
			onMoveEnd: this.onTaskMoveEnd.bind(this),
			onMoveAnimationEnd: this.onTaskMoveAnimationEnd.bind(this),
			// updateFreeDragData: this.updateTaskFreeDragData.bind(this),
			updateFreeDragData: this.updateAllocationFreeDragData.bind(this),
			// added allocation object to prevent crash whe dragging and dropping the task and when combineTasksAndProjectAllocations
			allocation: {
				projectId: task.projectId,
				projectGroupId: taskProject.projectGroupId,
			},
		};
	}

	updateTaskFreeDragData(dragData) {
		if (!dragData.groupData) return; //Don't update if there is no group under mouse
		const {group} = dragData.groupData;
		const {item} = dragData.itemData;
		const {initialGroup} = dragData;
		let outerParentGroup = group;
		while (outerParentGroup.parentGroup) {
			outerParentGroup = outerParentGroup.parentGroup;
		}
		if (outerParentGroup.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PERSON) {
			const personId = outerParentGroup.id;
			const projectId = item.data.task.projectId;
			const project = this.getData().projects.find(project => project.id === projectId);
			const allocationGroup = outerParentGroup.groups.find(
				allocationGroup => allocationGroup.id === `${personId}-${project.projectGroupId || projectId}`
			);
			if (!allocationGroup) {
				//Not assigned to project
				dragData.destinationGroup = outerParentGroup;
				dragData.innermostVisibleParentGroup = outerParentGroup;
			} else {
				if (this.isProjectGroupingDisabled()) {
					const commonGroup = outerParentGroup.groups.find(
						group => group.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PERSON_TASKS
					);
					dragData.destinationGroup = commonGroup;
					dragData.innermostVisibleParentGroup = outerParentGroup;
					if (outerParentGroup.expanded) {
						dragData.innermostVisibleParentGroup = commonGroup;
					}
					const currentGroupIdSplit = item.groupId.split('-');
					if (currentGroupIdSplit[0] !== personId) {
						item.groupId = `${personId}-${project.projectGroupId || project.id}-task`;
						item.resetItemRow();
					}
				} else {
					const taskGroup = allocationGroup.groups[0];
					dragData.destinationGroup = taskGroup;
					dragData.innermostVisibleParentGroup = outerParentGroup;
					if (outerParentGroup.expanded) {
						dragData.innermostVisibleParentGroup = allocationGroup;
						if (allocationGroup.expanded) {
							dragData.innermostVisibleParentGroup = taskGroup;
						}
					}
					if (item.groupId !== taskGroup.id) {
						item.groupId = taskGroup.id;
						item.resetItemRow();
					}
				}
			}
		} else {
			if (group.isInCollapsableSection) {
				if (initialGroup.isInCollapsableSection) {
					if (!group.groupType) return;
					item.groupId = `${group.data.roleId || 'no-role'}unassignedtask`;
					item.resetItemRow();
					let roleGroup = group;
					if (roleGroup.parentGroup) {
						roleGroup = roleGroup.parentGroup;
					}
					const taskGroup = roleGroup.groups[0];
					dragData.destinationGroup = taskGroup;
					dragData.innermostVisibleParentGroup = roleGroup;
					if (roleGroup.expanded) {
						dragData.innermostVisibleParentGroup = taskGroup;
					}
				} else {
					item.groupId = `${item.data.task.roleId || 'no-role'}unassignedtask`;
					item.resetItemRow();
					const roleGroup = this.state.collapsableSectionGroups.find(
						group => group.id === `${item.data.task.roleId || 'no-role'}`
					);
					const taskGroup = roleGroup.groups[0];
					dragData.destinationGroup = taskGroup;
					dragData.innermostVisibleParentGroup = roleGroup;
					if (roleGroup.expanded) {
						dragData.innermostVisibleParentGroup = taskGroup;
					}
				}
			}
		}
	}

	updateAllocationFreeDragData(dragData) {
		if (!dragData.groupData) return; //Don't update if there is no group under mouse
		const {group} = dragData.groupData;
		const {item} = dragData.itemData;
		const {initialGroup} = dragData;
		if (group.isInCollapsableSection) {
			dragData.destinationGroup = initialGroup;
			dragData.innermostVisibleParentGroup = null;
			return;
		}
		const outerGroupType = GROUP_TYPE.PEOPLE_SCHEDULING_PERSON;
		let outerParentGroup = group;
		while (outerParentGroup.parentGroup && outerParentGroup.groupType !== outerGroupType) {
			outerParentGroup = outerParentGroup.parentGroup;
		}
		if (outerParentGroup.groupType !== outerGroupType) {
			outerParentGroup = initialGroup;
			while (outerParentGroup.parentGroup && outerParentGroup.groupType !== outerGroupType) {
				outerParentGroup = outerParentGroup.parentGroup;
			}
		}
		const personId = outerParentGroup.id;
		let allocationGroup = outerParentGroup.groups.find(
			allocationGroup =>
				allocationGroup.id ===
				(item.data.allocation.idleTimeId
					? `${personId}-2`
					: `${personId}-${item.data.allocation.projectGroupId || item.data.allocation.projectId}`)
		);
		if (!allocationGroup) {
			//Not already assigned to project, so add project group for person
			const person = this.getData().persons.find(person => person.id === personId);

			const project = item.data.allocation.projectGroupId
				? this.getData().projectGroups.find(pg => pg.id === item.data.allocation.projectGroupId)
				: this.getData().projects.find(project => project.id === item.data.allocation.projectId);
			if (person && project) {
				allocationGroup = this.getNewProjectGroup(person, project);
				// Must be added before PlaceholderGroup to correctly determine visibility
				outerParentGroup.groups.splice(-1, 0, allocationGroup);
			}
		}
		if (!allocationGroup) {
			//Not assigned to project
			dragData.destinationGroup = outerParentGroup;
			dragData.innermostVisibleParentGroup = outerParentGroup;
		} else {
			dragData.destinationGroup = allocationGroup;
			dragData.innermostVisibleParentGroup = outerParentGroup;
			if (outerParentGroup.expanded) {
				dragData.innermostVisibleParentGroup = allocationGroup;
			}
			if (item.groupId !== allocationGroup.id) {
				item.groupId = allocationGroup.id;
				item.resetItemRow();
			}
		}
	}

	onDoneOrHaltedMoveAttempt(taskItem) {
		const {formatMessage} = this.props.intl;
		showModal({
			type: MODAL_TYPE.GENERIC,
			content: (
				<div>
					<Warning messageId="scheduling.done_warning" useInfoIcon={true} />
					<div className="warning-part-2">{formatMessage({id: 'scheduling.done_warning_2'})}</div>
				</div>
			),
			className: 'default-warning-modal',
			buttons: [
				{
					text: formatMessage({id: 'common.filter-close'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
			],
		});
	}

	onTaskMoveStart(taskItem, isResizing, dragData) {
		if (isResizing) return;
		for (const item of this.state.items) {
			if (
				item.data.isTaskTimeRegistration &&
				item.data.taskId === taskItem.data.task.id &&
				taskItem.groupId === item.groupId
			) {
				item.itemRow = taskItem.itemRow;
				item.show();
			}
		}
	}

	onTaskMoving(taskItem, group, startDateDelta, endDateDelta, dragData) {
		if (dragData.initialGroup && dragData.initialGroup.isInCollapsableSection) {
			for (const role of this.getData().roles) {
				if (this.heatmapCache.get(role.id)) {
					this.heatmapCache.get(role.id).needsRecalculation = true;
				}
			}
			if (this.heatmapCache.get(null)) {
				this.heatmapCache.get(null).needsRecalculation = true;
			}
		} else {
			if (this.heatmapCache.get(taskItem.data.task.roleId || null)) {
				this.heatmapCache.get(taskItem.data.task.roleId || null).needsRecalculation = true;
			}
		}

		for (const personId of taskItem.data.task.assignedPersons) {
			if (this.heatmapCache.get(personId)) {
				this.heatmapCache.get(personId).needsRecalculation = true;
			}
		}
		if (dragData.initialGroup) {
			let hoveredPersonGroup = group;
			while (hoveredPersonGroup.parentGroup) {
				hoveredPersonGroup = hoveredPersonGroup.parentGroup;
			}
			if (this.heatmapCache.get(hoveredPersonGroup.id)) {
				this.heatmapCache.get(hoveredPersonGroup.id).needsRecalculation = true;
			}
		}
		if (!dragData.initialTaskStartDate) {
			dragData.initialTaskStartDate = taskItem.data.taskStartDate;
			dragData.initialTaskEndDate = taskItem.data.taskEndDate;
		}
		if (this.isUsingNewTRU) {
			let isInActualMode =
				!this.getData().company.isUsingSchedulingPlanMode && !this.getData().company.isUsingProjectAllocation;
			if (this.isCalculationSwitched) {
				isInActualMode = !isInActualMode;
			}
			const utilizationStartDate = Math.min(dragData.initialTaskStartDate, dragData.newStartDate || taskItem.startDate);
			const utilizationEndDate = Math.max(dragData.initialTaskEndDate, dragData.newEndDate || taskItem.endDate);
			for (let i = utilizationStartDate; i <= utilizationEndDate; i++) {
				const dateString = `${this.timeline.minorStep}-${i}-${isInActualMode}`;
				if (this.companyUtilizationCache.get(dateString)) {
					this.companyUtilizationCache.get(dateString).needsRecalculation = true;
				}
			}
		}
		for (const item of this.state.items.filter(
			item => item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK && item.data.task.id === taskItem.data.task.id
		)) {
			const newTaskItemData = this.composeTaskItem(
				item.data.task,
				item.groupId.split('-')[0],
				this.state.todayDate,
				dragData.newStartDate || taskItem.startDate,
				dragData.newEndDate || taskItem.endDate
			);
			if (!newTaskItemData) continue;
			const {
				startDate,
				endDate,
				taskFragmentArray,
				taskDayFragmentArray,
				task,
				draggableArea,
				taskStartDate,
				taskEndDate,
			} = newTaskItemData;
			item.startDate = startDate;
			item.endDate = endDate;
			item.draggableArea = draggableArea;
			item.data.taskFragmentArray = taskFragmentArray;
			item.data.taskDayFragmentArray = taskDayFragmentArray;
			item.data.task = task;
			item.data.taskStartDate = taskStartDate;
			item.data.taskEndDate = taskEndDate;
		}

		return false;
	}

	onTaskMoveEnd(taskItem, group, initialGroup, dragData) {
		const {formatMessage} = this.props.intl;
		const assignedPersonIdSet = new Set();
		let roleId = taskItem.data.task.roleId;
		if (!group) {
			return;
		}
		const duplicateItemIndex = this.state.items.findIndex(
			item =>
				item !== taskItem &&
				item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK &&
				item.groupId === group.id &&
				item.data.task.id === taskItem.data.task.id
		);

		if (duplicateItemIndex >= 0) {
			this.state.items.splice(duplicateItemIndex, 1);
		}

		const sendMutation = () => {
			const assignedPersons = Array.from(assignedPersonIdSet);

			const startDate = getMomentFromCanvasTimelineDate(taskItem.data.taskStartDate);
			const endDate = getMomentFromCanvasTimelineDate(taskItem.data.taskEndDate);
			updateTask(
				{
					ids: [taskItem.data.task.id],
					startYear: startDate.year(),
					startMonth: startDate.month() + 1,
					startDay: startDate.date(),
					deadlineYear: endDate.year(),
					deadlineMonth: endDate.month() + 1,
					deadlineDay: endDate.date(),
					assignedPersons,
					roleId,
				},
				response => dispatch(EVENT_ID.SCHEDULING_MODAL_MUTATION_SUCCESS, response)
			);

			taskItem.data.task.startYear = startDate.year();
			taskItem.data.task.startMonth = startDate.month() + 1;
			taskItem.data.task.startDay = startDate.date();
			taskItem.data.task.deadlineYear = endDate.year();
			taskItem.data.task.deadlineMonth = endDate.month() + 1;
			taskItem.data.task.deadlineDay = endDate.date();
			taskItem.data.task.assignedPersons = assignedPersons;
			if (!this.isUsingNewTRU) {
				this.clearCompanyUtilizationCache();
			}
		};

		if (
			[GROUP_TYPE.PEOPLE_SCHEDULING_UNASSIGNED_ROLE, GROUP_TYPE.PEOPLE_SCHEDULING_UNASSIGNED_ROLE_TASK].includes(
				group.groupType
			)
		) {
			taskItem.data.task.roleId = group.data.roleId;
			roleId = group.data.roleId;
			if (taskItem.data.task.assignedPersons.length > 1) {
				const revertMove = () => {
					taskItem.groupId = initialGroup.id;
					for (const item of this.state.items.filter(
						item =>
							item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK && item.data.task.id === taskItem.data.task.id
					)) {
						const newTaskItemData = this.composeTaskItem(
							item.data.task,
							item.groupId.split('-')[0],
							this.state.todayDate,
							dragData.taskInitialStartDate || taskItem.data.taskStartDate,
							dragData.taskInitialEndDate || taskItem.data.taskEndDate
						);
						if (!newTaskItemData) continue;
						const {
							startDate,
							endDate,
							taskFragmentArray,
							taskDayFragmentArray,
							task,
							draggableArea,
							taskStartDate,
							taskEndDate,
						} = newTaskItemData;
						item.startDate = startDate;
						item.endDate = endDate;
						item.draggableArea = draggableArea;
						item.data.taskFragmentArray = taskFragmentArray;
						item.data.taskDayFragmentArray = taskDayFragmentArray;
						item.data.task = task;
						item.data.taskStartDate = taskStartDate;
						item.data.taskEndDate = taskEndDate;
					}
					dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
				};
				const warningMessage = formatMessage(
					{id: 'scheduling.warning_assigned_to_many'},
					{
						taskName: `"T${taskItem.data.task.companyTaskId} ${taskItem.data.task.name}"`,
					}
				);
				showModal({
					type: MODAL_TYPE.GENERIC,
					content: (
						<div>
							<Warning message={warningMessage} />
						</div>
					),
					className: 'default-warning-modal',
					defaultCallback: revertMove,
					buttons: [
						{
							text: formatMessage({id: 'common.cancel'}),
							callback: revertMove,
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.WHITE,
						},
						{
							text: formatMessage({id: 'common.continue'}),
							callback: sendMutation,
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.GREEN,
						},
					],
				});
			} else {
				sendMutation();
			}
		} else {
			let targetGroup = group;
			if (targetGroup.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PERSON) {
				//Project group was not found
				const project = this.getData().projects.find(project => project.id === taskItem.data.task.projectId);
				const isConnectedProject = !!project.projectGroupId;
				const connectedProject = isConnectedProject
					? this.getData().projectGroups.find(projectGroup => projectGroup.id === project.projectGroupId)
					: null;
				const newProject = isConnectedProject ? connectedProject : project;
				const projectGroup = this.getNewProjectGroup(group.data, newProject);
				taskItem.groupId = projectGroup.id;
			}
			for (const personId of taskItem.data.task.assignedPersons) {
				assignedPersonIdSet.add(personId);
			}
			if (initialGroup && initialGroup !== targetGroup) {
				assignedPersonIdSet.delete(initialGroup.id.split('-')[0]);
				if (
					![GROUP_TYPE.PEOPLE_SCHEDULING_UNASSIGNED_ROLE, GROUP_TYPE.PEOPLE_SCHEDULING_UNASSIGNED_ROLE_TASK].includes(
						targetGroup.groupType
					)
				) {
					assignedPersonIdSet.add(targetGroup.id.split('-')[0]);
				}
			}
			sendMutation();
		}
	}

	onTaskMoveAnimationEnd() {}

	getNewProjectGroup(person, project) {
		const data = this.getData();
		const isConnectedProject = project.projectGroupId
			? data.projectGroups.some(projectGroup => projectGroup.id === project.projectGroupId)
			: !!project.companyProjectGroupId;
		const isDoneOrHalted = ['DONE', 'HALTED'].includes(project.status);
		let clientName =
			project && project.clientId ? this.getData().clients.find(client => client.id === project.clientId).name : '';
		const isDisabled =
			!hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL) &&
			!data.projectPersons.find(
				projectPerson => projectPerson.personId === data.viewer.actualPersonId && projectPerson.projectId === project.id
			);

		//If the project is a greyed out project in project manager view, show project contact name instead of client name if there is one
		if (isDisabled) {
			const projectContact = data.projectPersons.find(
				projectPerson => projectPerson.isContactPerson && projectPerson.projectId === project.id
			);
			if (projectContact) {
				const projectContactPerson = data.persons.find(person => person.id === projectContact.personId);
				clientName = `Ct: ${projectContactPerson.firstName} ${projectContactPerson.lastName || ''}`;
			} else {
				clientName = '';
			}
		}
		const hasCreateItemPermission =
			!data.company.isUsingProjectAllocation || hasPermission(PERMISSION_TYPE.ALLOCATION_CREATE);
		const noGrouping = this.state.peopleSchedulingOptions.groupBy === GROUP_BY.NONE;

		const newProjectGroup = new ProjectGroup({
			id: `${person.id}-${project.id}`,
			personId: person.id,
			companyProjectId: isConnectedProject ? undefined : project.companyProjectId,
			companyProjectGroupId: isConnectedProject ? project.companyProjectGroupId : undefined,
			name: project.name,
			color: isConnectedProject ? project.color : project.projectColor,
			status: isConnectedProject ? undefined : project.status,
			client: isConnectedProject ? undefined : project.clientId,
			estimationUnit: project.estimationUnit,
			clientName: clientName,
			hideIfEmpty: true,
			preventExpansion: true,
			isConnectedProject: isConnectedProject,
			marginX: noGrouping ? 0 : 32,
			onMouseEnter: this.onProjectGroupMouseEnter.bind(this, project, person),
			onMouseLeave: this.onProjectGroupMouseLeave.bind(this, project),
			hideCondition: () => {
				return this.isProjectGroupingDisabled();
			},
			onItemCreate:
				isDisabled || !hasCreateItemPermission || isDoneOrHalted || project.isJiraProject
					? undefined
					: (startDate, endDate, group) => {
							const momentStartDate = getMomentFromCanvasTimelineDate(startDate);
							const momentEndDate = getMomentFromCanvasTimelineDate(endDate);
							showModal({
								type: MODAL_TYPE.CANVAS_CREATE,
								projectGroups: data.projectGroups,
								projects: data.projects,
								idleTimes: data.idleTimes,
								projectPersons: data.projectPersons,
								actualPersonId: data.viewer.actualPersonId,
								persons: data.persons,
								selectedPersonId: person.id,
								selectedProject: project,
								milestones: data.phases,
								company: data.company,
								holidayCalendars: data.holidayCalendars,
								holidayCalendarEntries: data.holidayCalendarEntries,
								allocation: {
									personId: person.id,
									startDay: momentStartDate.date(),
									startMonth: momentStartDate.month() + 1,
									startYear: momentStartDate.year(),
									endDay: momentEndDate.date(),
									endMonth: momentEndDate.month() + 1,
									endYear: momentEndDate.year(),
									monday: person.monday,
									tuesday: person.tuesday,
									wednesday: person.wednesday,
									thursday: person.thursday,
									friday: person.friday,
									saturday: person.saturday,
									sunday: person.sunday,
									registerTime: false,
								},
								roles: data.roles,
								teams: data.teams,
								teamPersons: data.teamPersons,
								removeLowHigh: data.viewer.availableFeatureFlags.some(flag => flag.key === 'remove_low_high'),
							});
					  },
		});

		return newProjectGroup;
	}

	getCollapsableSectionGroupsFromProps(props, data) {
		const roleTaskCountMap = new Map();
		const {projectIdMap} = this.getProjectMap(data);
		data.tasks
			.filter(
				task =>
					task.startYear !== undefined &&
					task.startYear !== null &&
					task.deadlineYear !== undefined &&
					task.deadlineYear !== null &&
					!task.done &&
					projectIdMap.get(task.projectId) &&
					![PROJECT_STATUS.HALTED, PROJECT_STATUS.DONE].includes(projectIdMap.get(task.projectId).status) &&
					task.assignedPersons.length === 0
			)
			.forEach(task => {
				let taskCount = 1;
				if (roleTaskCountMap.has(task.roleId ? task.roleId : 'no-role')) {
					taskCount = roleTaskCountMap.get(task.roleId ? task.roleId : 'no-role') + 1;
				}
				roleTaskCountMap.set(task.roleId ? task.roleId : 'no-role', taskCount);
			});
		let groups = [];

		const onItemCreate = (selectedRole, startDate, endDate, group) => {
			showModal({
				type: MODAL_TYPE.CANVAS_CREATE_NEW_MODAL,
				roles: data.roles,
				persons: data.persons,
				projects: data.projects,
				phases: data.phases,
				projectPersons: data.projectPersons,
				startDate: getMomentFromCanvasTimelineDate(startDate),
				endDate: getMomentFromCanvasTimelineDate(endDate),
				viewerId: data.viewer.actualPersonId,
				selectedRole,
				removeLowHigh: data.viewer.availableFeatureFlags.some(flag => flag.key === 'remove_low_high'),
			});
		};

		const noRoleTaskGroups = [
			new UnassignedRoleTaskGroup({
				id: `no-roleunassignedtask`,
				onMouseEnter: this.onTaskGroupMouseEnter.bind(this, 'no-roleunassignedtask', true, false, false),
				onMouseLeave: this.onTaskGroupMouseLeave.bind(this),
				roleId: null,
				onItemCreate: onItemCreate.bind(this, null),
			}),
		];
		const noRoleGroup = new UnassignedRoleGroup({
			id: 'no-role',
			name: props.intl.formatMessage({id: 'card_modal.no-role'}),
			groups: noRoleTaskGroups,
			tasks: data.tasks,
			projectPersons: data.projectPersons,
			viewer: data.viewer,
			projects: data.projects,
			composeItems: this.composeUnassignedHeatmapRow.bind(this),
			roleId: null,
			getItems: () => {
				return this.state.items;
			},
		});
		groups.push(noRoleGroup);
		for (const role of data.roles.sort((a, b) => a.name.localeCompare(b.name))) {
			const taskGroups = [
				new UnassignedRoleTaskGroup({
					id: `${role.id}unassignedtask`,
					onMouseEnter: this.onTaskGroupMouseEnter.bind(this, `${role.id}unassignedtask`, true, false, false),
					onMouseLeave: this.onTaskGroupMouseLeave.bind(this),
					roleId: role.id,
					onItemCreate: onItemCreate.bind(this, {id: role.id, name: role.name}),
				}),
			];
			groups.push(
				new UnassignedRoleGroup({
					id: role.id,
					name: role.name,
					groups: taskGroups,
					tasks: data.tasks,
					projectPersons: data.projectPersons,
					viewer: data.viewer,
					projects: data.projects,
					composeItems: this.composeUnassignedHeatmapRow.bind(this),
					roleId: role.id,
					getItems: () => {
						return this.state.items;
					},
				})
			);
		}

		const getGroupTaskCount = group => {
			return group.data.tasks.filter(
				task =>
					task.startDay &&
					task.deadlineDay &&
					!task.done &&
					task.assignedPersons.length === 0 &&
					(task.roleId || null) === group.data.roleId &&
					group.data.projects.find(project => project.id === task.projectId) &&
					![PROJECT_STATUS.HALTED, PROJECT_STATUS.DONE].includes(
						group.data.projects.find(project => project.id === task.projectId).status
					)
			).length;
		};

		for (const group of groups) {
			group.taskCount = getGroupTaskCount(group);
		}

		return groups;
	}

	composeUnassignedHeatmapRow(group, stepDataArray, timelineStartDate, pixelsPerDay, timelineMinorStep) {
		const roleId = group.id === 'no-role' ? null : group.id;
		const {company} = this.getData();
		const {items, todayDate} = this.state;
		//Company default working time for each week day
		const companyWorkingMinutes = [
			company.monday,
			company.tuesday,
			company.wednesday,
			company.thursday,
			company.friday,
			company.saturday,
			company.sunday,
		];
		//Average working time on days with more than 0 minutes
		const companyWorkingDayCount = companyWorkingMinutes.reduce((total, minutes) => total + (minutes === 0 ? 0 : 1), 0);
		const companyAverageWorkingMinutes =
			companyWorkingMinutes.reduce((total, minutes) => total + minutes, 0) / companyWorkingDayCount;

		//Initialize heatmapCache if it does not exist
		if (!this.heatmapCache.has(roleId)) {
			this.heatmapCache.set(roleId, new Map());
		}

		const heatmapItems = [];
		for (const stepData of stepDataArray) {
			let minutesAllocated = 0;
			let requiredPersonCount = 0;
			let {startDate, endDate} = stepData;
			const dateString = `${roleId}-${timelineMinorStep}-${startDate}`;
			const cachedRoleItem = this.heatmapCache.get(roleId);
			if (!cachedRoleItem.needsRecalculation && cachedRoleItem.has(dateString)) {
				const cachedItem = cachedRoleItem.get(dateString);
				//cachedItem will be null if heatmap is empty
				if (cachedItem) {
					heatmapItems.push(
						new UnassignedHeatmapItem({
							y: group.screenY,
							x: stepData.position,
							width: stepData.width,
							hoursAllocatedText: cachedItem.hoursAllocatedText,
							requiredPersonCount: cachedItem.requiredPersonCount,
						})
					);
				}
				continue;
			}
			for (const item of items) {
				if (
					item.filtered ||
					item.startDate > endDate ||
					item.endDate < startDate - 1 ||
					item.groupId !== group.id + 'unassignedtask'
				)
					continue;
				const {task, isHourEstimated, minutesPerEstimationPoint} = item.data;
				let {timeLeft} = task;
				//Peace out if task has no remaining since it will not affect heatmap regardless of its position
				if (timeLeft <= 0) continue;
				if (!isHourEstimated) {
					timeLeft *= minutesPerEstimationPoint;
				}

				const isInThePast = item.endDate < todayDate;
				//If task is completely in the past or completely in the future, use normal task start date for calculation
				//If task is partially in the past and partially in the future, use today as the starting date
				const calculationStartDate = isInThePast ? item.startDate : Math.max(todayDate, item.startDate);
				//How many weekdays are in the task (ex: 1 monday, 1 tuesday, 1 wednesday)
				const taskTotalWeekdays = getWeekdaysBetweenDates(calculationStartDate, item.endDate);
				//Weekdays which are within the current loop period
				const taskLoopWeekdays = getWeekdaysBetweenDates(
					Math.max(calculationStartDate, startDate),
					Math.min(item.endDate, endDate)
				);
				//Total length of task in days
				const taskTotalDayCount = taskTotalWeekdays.reduce((total, weekdayCount) => {
					return total + weekdayCount;
				}, 0);
				//Total length of task in days minus days on which the company has 0 work minutes
				const taskWorkingDayCount = taskTotalWeekdays.reduce((total, weekdayCount, index) => {
					return total + (companyWorkingMinutes[index] ? weekdayCount : 0);
				}, 0);
				//Number of days within current loop period
				const taskLoopTotalDayCount = taskLoopWeekdays.reduce((total, weekdayCount) => {
					return total + weekdayCount;
				}, 0);
				//Number of days within current loop period minus days on which the company has 0 work minutes
				const taskLoopWorkingDayCount = taskLoopWeekdays.reduce((total, weekdayCount, index) => {
					return total + (companyWorkingMinutes[index] ? weekdayCount : 0);
				}, 0);
				//If there are any working days during the task's period, spread timeLeft evenly among working days only
				//If there are no working days during the task's period, spread timeLeft evenly among all days
				if (taskWorkingDayCount) {
					minutesAllocated += (timeLeft * taskLoopWorkingDayCount) / taskWorkingDayCount;
					//Calculate how many people are required to finish the task on time
					const taskMinutesAvailable = getMinutesInWeekdays(
						company,
						getWeekdaysBetweenDates(Math.max(calculationStartDate, startDate), Math.min(item.endDate, endDate))
					);
					if (taskMinutesAvailable) {
						const taskRequiredPersonCount = Math.ceil(minutesAllocated / taskMinutesAvailable);
						if (taskRequiredPersonCount > requiredPersonCount) {
							requiredPersonCount = taskRequiredPersonCount;
						}
					}
				} else {
					minutesAllocated += (timeLeft * taskLoopTotalDayCount) / taskTotalDayCount;
					//Calculate how many people are required to finish the task on time
					//No working days during the task, using average working time instead
					const taskRequiredPersonCount = Math.ceil(
						minutesAllocated / companyAverageWorkingMinutes / taskLoopTotalDayCount
					);
					if (taskRequiredPersonCount > requiredPersonCount) {
						requiredPersonCount = taskRequiredPersonCount;
					}
				}
			}
			const hoursAllocatedText = Util.convertMinutesToFullHour(minutesAllocated, this.props.intl);
			cachedRoleItem.set(dateString, minutesAllocated ? {requiredPersonCount, hoursAllocatedText} : null);
			heatmapItems.push(
				new UnassignedHeatmapItem({
					y: group.screenY,
					x: stepData.position,
					width: stepData.width,
					hoursAllocatedText,
					requiredPersonCount,
				})
			);
		}
		return heatmapItems;
	}

	// function that prepares data and starts the person_heatmap worker

	constructCanvasItem(type, {group, stepData, onClick, minutesAllocated, minutesAvailable}) {
		const {intl} = this.props;
		const data = this.getData();

		const defaultHolidayCalendarEntries = data.holidayCalendarEntries.filter(
			entry => entry.holidayCalendarId === data.company.defaultHolidayCalendarId
		);
		const defaultHolidaysEntriesCanvasFormat = defaultHolidayCalendarEntries.map(entry =>
			createCanvasTimelineDate(entry.year, entry.month, entry.day)
		);
		let isDefaultFreeDay =
			stepData.isWeekend ||
			defaultHolidaysEntriesCanvasFormat.find(day => stepData.startDate === day && stepData.endDate === day);

		if (type === 'freeday') {
			return new FreeDayItem({
				y: group.screenY,
				x: stepData.position,
				width: stepData.width,
				groupHeight: group.totalHeight,
				onClick,
				isDefaultFreeDay,
			});
		} else if (type === 'timeoff') {
			return new TimeOffItem({
				y: group.screenY,
				x: stepData.position,
				width: stepData.width,
				groupHeight: group.totalHeight,
				onClick,
				intl,
			});
		} else if (type === 'utilization') {
			const personIndex = data.persons.findIndex(person => person.id === group.data.personId);
			return new HeatmapItem({
				y: group.screenY,
				x: stepData.position,
				intl,
				width: stepData.width,
				minutesAllocated,
				minutesAvailable,
				groupHeight: group.totalHeight,
				onClick,
				eyeOptions: this.state.peopleSchedulingDetailSelectorOptions,
				isDefaultFreeDay,
				isPast: stepData.endDate < this.state.todayDate,
				isInActualMode: !data.company.isUsingSchedulingPlanMode && !data.company.isUsingProjectAllocation,
				personIndex,
				utilizationFormat: this.state.peopleSchedulingOptions.utilizationFormat,
			});
		}
	}

	getHeatMapData(group, stepDataArray, overallStartDate, overallEndDate, timelineMinorStep) {
		const person = group.data;
		const data = this.getData();
		const isUsingProjectAllocation = data.company.isUsingProjectAllocation;
		let isInActualMode = !data.company.isUsingSchedulingPlanMode && !isUsingProjectAllocation;

		if (this.isCalculationSwitched) {
			isInActualMode = !isInActualMode;
		}

		//Initialize heatmapCache if it does not exist
		if (!this.heatmapCache.has(person.id)) {
			this.heatmapCache.set(person.id, new Map());
		}

		const personCache = this.heatmapCache.get(person.id);
		const dateString = `${person.id}-${timelineMinorStep}-${overallStartDate}-${isInActualMode}`;
		let cachedItem = personCache.get(dateString);

		const startDate = person.startDate ? Math.max(overallStartDate, person.startDate) : overallStartDate;
		const endDate = person.endDate ? Math.min(overallEndDate, person.endDate) : overallEndDate;
		if (!cachedItem || personCache.needsRecalculation) {
			const {items, todayDate} = this.state;
			const {dayData} = this.props;
			const personWorkingMinutes = [
				person.monday,
				person.tuesday,
				person.wednesday,
				person.thursday,
				person.friday,
				person.saturday,
				person.sunday,
			];
			const {holidaysIncludingDaysOff, holidaysExcludingDaysOff} = getHolidayDates(person, data, personWorkingMinutes);

			let minutesAllocated = 0;

			// Find items that are relevant to the stepDataArray
			const firstStartDate = stepDataArray[0].startDate;
			const lastEndDate = stepDataArray[stepDataArray.length - 1].endDate;
			const relevantItems = items.filter(item => {
				if (item.groupId) {
					const itemPersonId = item.groupId.split('-')[0];
					return itemPersonId === person.id && !(item.startDate > lastEndDate || item.endDate < firstStartDate);
				}
				return false;
			});

			//Get ids of groups that contain relevant items
			let projectAllocationGroupIds = [];
			for (const childGroup of group.groups) {
				if (childGroup.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PROJECT) {
					if (isUsingProjectAllocation) {
						projectAllocationGroupIds.push(childGroup.id);
					}
				}
			}

			const getHolidayCountInPeriod = (periodStartDate, periodEndDate) => {
				return holidaysExcludingDaysOff.filter(date => {
					return date >= periodStartDate && date <= periodEndDate;
				}).length;
			};

			const weekdaysInPeriod = getWeekdaysBetweenDates(startDate, endDate);
			for (const holidayCalendarEntryDate of holidaysIncludingDaysOff.filter(
				date => date >= startDate && date <= endDate
			)) {
				weekdaysInPeriod[dayData[holidayCalendarEntryDate].isoWeekday - 1]--;
			}
			for (let canvasDate = startDate; canvasDate <= endDate; canvasDate++) {
				if (!isDateWithinPersonStartEndDate(person, canvasDate)) {
					weekdaysInPeriod[dayData[canvasDate].isoWeekday - 1] = Math.max(
						weekdaysInPeriod[dayData[canvasDate].isoWeekday - 1] - 1,
						0
					);
				}
			}
			let minutesAvailable = getMinutesInWeekdays(person, weekdaysInPeriod);
			const distributionMap = new Map();
			const addToDistributionMap = (id, minutes) => {
				if (!distributionMap.has(id)) {
					distributionMap.set(id, 0);
				}
				distributionMap.set(id, distributionMap.get(id) + minutes);
			};
			const idleTimeDataMap = new Map();

			const taskItemMap = new Map();
			for (const item of relevantItems) {
				if (item.startDate > endDate || item.endDate < startDate) continue;
				if (item.groupId === person.id + '-1') {
					//Ignore idle time time registrations in planning mode
					if (!isInActualMode) continue;
					//Ignore if not within loop period
					if (item.startDate > endDate || item.endDate < startDate) continue;
					//If there is something on this day already, update values, otherwise insert new value

					if (!idleTimeDataMap.has(item.startDate)) {
						idleTimeDataMap.set(item.startDate, []);
					}
					idleTimeDataMap.get(item.startDate).push({
						id: item.data.idleTimeId,
						idleTimeMinutesAllocated: 0,
						timeOffMinutesAllocated: 0,
						idleTimeMinutesRegistered: item.data.isIdleTimeInternal ? item.data.minutesRegistered : 0,
						timeOffMinutesRegistered: item.data.isIdleTimeInternal ? 0 : item.data.minutesRegistered,
					});
				} else if (item.groupId === person.id + '-2') {
					//Ignore holidays
					if (item.data.isHoliday) continue;
					//Need to loop through every single day of allocation even if not on day view
					let idleTimeAllocationLoopDate = Math.max(startDate, item.startDate);
					const idleTimeAllocationLoopEndDate = Math.min(endDate, item.endDate);
					while (idleTimeAllocationLoopDate <= idleTimeAllocationLoopEndDate) {
						// Disregard past allocations of idle time in actual mode
						if (isInActualMode && idleTimeAllocationLoopDate < todayDate) {
							idleTimeAllocationLoopDate++;
							continue;
						}
						const allocationMinutes = getMinutesInWeekdays(
							item.data.allocation,
							getWeekdaysBetweenDates(idleTimeAllocationLoopDate, idleTimeAllocationLoopDate)
						);
						//If there is something on this day already, update values, otherwise insert new value

						if (!idleTimeDataMap.has(idleTimeAllocationLoopDate)) {
							idleTimeDataMap.set(idleTimeAllocationLoopDate, []);
						}
						idleTimeDataMap.get(idleTimeAllocationLoopDate).push({
							id: item.data.allocation.idleTimeId,
							idleTimeMinutesAllocated: item.data.allocation.isIdleTimeInternal ? allocationMinutes : 0,
							timeOffMinutesAllocated: item.data.allocation.isIdleTimeInternal ? 0 : allocationMinutes,
							idleTimeMinutesRegistered: 0,
							timeOffMinutesRegistered: 0,
						});
						idleTimeAllocationLoopDate++;
					}
				} else if (
					item.itemType !== ITEM_TYPE.PEOPLE_SCHEDULING_TASK &&
					projectAllocationGroupIds.indexOf(item.groupId) !== -1
				) {
					const calculationStartDate = isInActualMode ? Math.max(todayDate, item.startDate) : item.startDate;
					const weekdaysInPeriod = getWeekdaysBetweenDates(
						Math.max(startDate, calculationStartDate),
						Math.min(endDate, item.endDate)
					);
					let allocationMinutes = getMinutesInWeekdays(item.data.allocation, weekdaysInPeriod);
					minutesAllocated += allocationMinutes;
					addToDistributionMap(
						item.data.allocation.projectGroupId || item.data.allocation.projectId,
						allocationMinutes
					);
				} else if (!isUsingProjectAllocation && item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK) {
					if (taskItemMap.has(item.data.task.id)) {
						taskItemMap.get(item.data.task.id).taskItem = item;
					} else {
						taskItemMap.set(item.data.task.id, {
							taskItem: item,
							timeRegistrationItems: data.timeRegistrations.filter(
								timeReg => timeReg.taskId === item.data.task.id
							),
						});
					}
				}
			}
			if (isInActualMode) {
				const personTimeRegs = data.timeRegistrations.filter(timeReg => timeReg.personId === person.id);
				for (const timeReg of personTimeRegs) {
					const timeRegDate = createCanvasTimelineDate(timeReg.year, timeReg.month, timeReg.day);
					if (timeRegDate >= startDate && timeRegDate <= endDate && timeRegDate < todayDate) {
						minutesAllocated += timeReg.minutesRegistered;
						const distributionMapId =
							timeReg.projectId ||
							timeReg.idleTimeId ||
							(timeReg.taskId ? taskItemMap.get(timeReg.taskId)?.taskItem.data.task.projectId : null);
						if (distributionMapId) {
							addToDistributionMap(distributionMapId, timeReg.minutesRegistered);
						}
					}
				}
			}

			for (const entry of taskItemMap.entries()) {
				if (isInActualMode) {
					const {taskItem, timeRegistrationItems} = entry[1];
					if (taskItem) {
						const {task, taskStartDate, taskEndDate, isHourEstimated, minutesPerEstimationPoint} = taskItem.data;
						let {timeLeft} = task;
						if (!isHourEstimated) {
							timeLeft *= minutesPerEstimationPoint;
						}
						let totalMinutesRegistered = 0;
						let futureMinutesRegistered = 0;
						for (const item of timeRegistrationItems) {
							//Increase task timeLeft by all future time registrations for the purpose of heatmap calculations
							if (item.date >= todayDate) {
								//Ignore scenario where the task is completely in the past but has a time registration in the future
								if (taskEndDate >= todayDate) {
									futureMinutesRegistered += item.minutesRegistered;
								}
							}
							totalMinutesRegistered += item.minutesRegistered;
						}
						const taskProject = data.projects.find(project => project.id === task.projectId);

						// If remaining wasn't manually set, calculate it
						if (
							taskProject &&
							taskProject.remainingAutoCalculated &&
							(taskProject.taskLevels !== 2 || task.subTaskCount === 0)
						) {
							let estimate = task.estimateForecast;
							if (!isHourEstimated) {
								estimate *= minutesPerEstimationPoint;
							}
							timeLeft = estimate - totalMinutesRegistered + futureMinutesRegistered;
						}
						//Peace out if task has no remaining since it will not affect heatmap regardless of its position
						if (timeLeft <= 0) continue;
						//Check if task is within current loop period (can get to this point if only a time registration outside of task is within looped period)

						if (!(taskStartDate > endDate || taskEndDate < startDate - 1)) {
							const isInThePast = taskEndDate < todayDate;
							//We do not care about tasks in the past
							if (isInThePast) continue;
							//If task is partially in the past and partially in the future, use today as the starting date
							const calculationStartDate = Math.max(todayDate, taskStartDate);
							//How many weekdays are in the task (ex: 1 monday, 1 tuesday, 1 wednesday)
							const taskTotalWeekdays = getWeekdaysBetweenDates(calculationStartDate, taskEndDate);
							//Weekdays which are within the current loop period
							const taskLoopWeekdays = getWeekdaysBetweenDates(
								Math.max(calculationStartDate, startDate),
								Math.min(taskEndDate, endDate)
							);

							//Total length of task in days minus days on which the person is supposed to work 0 minutes
							const taskWorkingDayCount =
								taskTotalWeekdays.reduce((total, weekdayCount, index) => {
									return total + (personWorkingMinutes[index] ? weekdayCount : 0);
								}, 0) - getHolidayCountInPeriod(calculationStartDate, taskEndDate);

							//If there are any working days during the task's period, spread timeLeft evenly among working days only
							//If there are no working days during the task's period, spread timeLeft evenly among all days
							//Always divide by amount of people assigned
							if (taskWorkingDayCount) {
								//Number of days within current loop period minus days on which the person is supposed to work 0 minutes
								const taskLoopWorkingDayCount =
									taskLoopWeekdays.reduce((total, weekdayCount, index) => {
										return total + (personWorkingMinutes[index] ? weekdayCount : 0);
									}, 0) -
									getHolidayCountInPeriod(
										Math.max(calculationStartDate, startDate),
										Math.min(taskEndDate, endDate)
									);
								const taskMinutesAllocated =
									(timeLeft * taskLoopWorkingDayCount) /
									taskWorkingDayCount /
									(task.assignedPersons.length || 1);
								minutesAllocated += taskMinutesAllocated;
								addToDistributionMap(taskItem.groupId.split('-')[1], taskMinutesAllocated);
							} else {
								//Total length of task in days
								const taskTotalDayCount = taskTotalWeekdays.reduce(
									(total, weekdayCount) => total + weekdayCount,
									0
								);
								if (taskTotalDayCount > 0) {
									//Number of days within current loop period
									const taskLoopTotalDayCount = taskLoopWeekdays.reduce(
										(total, weekdayCount) => total + weekdayCount,
										0
									);
									const taskMinutesAllocated =
										(timeLeft * taskLoopTotalDayCount) /
										taskTotalDayCount /
										(task.assignedPersons.length || 1);
									minutesAllocated += taskMinutesAllocated;
									addToDistributionMap(taskItem.groupId.split('-')[1], taskMinutesAllocated);
								}
							}
						}
					}
				} else {
					const {taskItem} = entry[1];
					if (!taskItem) continue;
					const {task, taskStartDate, taskEndDate, isHourEstimated, minutesPerEstimationPoint} = taskItem.data;
					let {estimateForecast} = task;
					//Tasks with no forecast do not contribute anything
					if (!estimateForecast) continue;
					if (!isHourEstimated) {
						estimateForecast *= minutesPerEstimationPoint;
					}
					//Check if task is in current loop period
					if (taskStartDate > endDate || taskEndDate < startDate - 1) continue;

					//If a task is outside the employment period, calculate it as having a shorter duration
					let taskPersonActualStartDate = taskStartDate;
					if (person.startDate && taskStartDate < person.startDate) {
						taskPersonActualStartDate = person.startDate;
					}
					let taskPersonActualEndDate = taskEndDate;
					if (person.endDate && taskEndDate > person.endDate) {
						taskPersonActualEndDate = person.endDate;
					}

					//How many weekdays are in the task (ex: 1 monday, 1 tuesday, 1 wednesday)
					const taskTotalWeekdays = getWeekdaysBetweenDates(taskPersonActualStartDate, taskPersonActualEndDate);

					//Weekdays which are within the current loop period
					const taskLoopWeekdays = getWeekdaysBetweenDates(
						Math.max(taskPersonActualStartDate, startDate),
						Math.min(taskPersonActualEndDate, endDate)
					);

					//Total length of task in days minus days on which the person is supposed to work 0 minutes
					const taskWorkingDayCount =
						taskTotalWeekdays.reduce((total, weekdayCount, index) => {
							return total + (personWorkingMinutes[index] ? weekdayCount : 0);
						}, 0) - getHolidayCountInPeriod(taskPersonActualStartDate, taskPersonActualEndDate);

					//If there are any working days during the task's period, spread forecast evenly among working days only
					//If there are no working days during the task's period, spread forecast evenly among all days
					//Always divide by amount of people assigned
					if (taskWorkingDayCount) {
						//Number of days within current loop period minus days on which the person is supposed to work 0 minutes
						const taskLoopWorkingDayCount =
							taskLoopWeekdays.reduce((total, weekdayCount, index) => {
								return total + (personWorkingMinutes[index] ? weekdayCount : 0);
							}, 0) -
							getHolidayCountInPeriod(
								Math.max(taskPersonActualStartDate, startDate),
								Math.min(taskPersonActualEndDate, endDate)
							);
						const taskMinutesAllocated =
							(estimateForecast * taskLoopWorkingDayCount) /
							taskWorkingDayCount /
							(task.assignedPersons.length || 1);
						minutesAllocated += taskMinutesAllocated;
						addToDistributionMap(taskItem.groupId.split('-')[1], taskMinutesAllocated);
					} else {
						//Total length of task in days
						const taskTotalDayCount = taskTotalWeekdays.reduce((total, weekdayCount) => total + weekdayCount, 0);
						//Number of days within current loop period
						const taskLoopTotalDayCount = taskLoopWeekdays.reduce((total, weekdayCount) => total + weekdayCount, 0);
						const taskMinutesAllocated =
							(estimateForecast * taskLoopTotalDayCount) / taskTotalDayCount / (task.assignedPersons.length || 1);
						minutesAllocated += taskMinutesAllocated;
						addToDistributionMap(taskItem.groupId.split('-')[1], taskMinutesAllocated);
					}
				}
			}

			// Looping through idleTimeDataMap to calc minues allocated, add them to the distribution map, and to subtract from available time.
			for (const day of idleTimeDataMap.keys()) {
				const mapById = idleTimeDataMap.get(day).reduce((acc, cur) => {
					if (acc.has(cur.id)) {
						const idleTime = acc.get(cur.id);
						idleTime.idleTimeMinutesRegistered += cur.idleTimeMinutesRegistered;
						idleTime.idleTimeMinutesAllocated += cur.idleTimeMinutesAllocated;
						idleTime.timeOffMinutesRegistered += cur.timeOffMinutesRegistered;
						idleTime.timeOffMinutesAllocated += cur.timeOffMinutesAllocated;
						acc.set(cur.id, idleTime);
					} else {
						acc.set(cur.id, cur);
					}
					return acc;
				}, new Map());
				// Check if this day is a holiday
				const isHoliday = holidaysIncludingDaysOff.includes(day);
				// Calc the persons minutes available for this day
				const minutesAvailableForDay = isHoliday ? 0 : personWorkingMinutes[dayData[day].isoWeekday - 1];
				let totalTimeOffForDay = 0;
				for (const idleTime of mapById.values()) {
					const {
						idleTimeMinutesRegistered,
						idleTimeMinutesAllocated,
						timeOffMinutesRegistered,
						timeOffMinutesAllocated,
						id,
					} = idleTime;
					const _idleTimeMinutesAllocated =
						isInActualMode && day < todayDate ? idleTimeMinutesRegistered : idleTimeMinutesAllocated;
					const _timeOffMinutesAllocated =
						isInActualMode && day < todayDate ? timeOffMinutesRegistered : timeOffMinutesAllocated;
					minutesAllocated += _idleTimeMinutesAllocated;
					if (_idleTimeMinutesAllocated) {
						addToDistributionMap(id, _idleTimeMinutesAllocated);
					} else if (_timeOffMinutesAllocated) {
						addToDistributionMap(id, _timeOffMinutesAllocated);
					}

					totalTimeOffForDay += _timeOffMinutesAllocated;
				}
				// External idle time subtracts from available time
				minutesAvailable -= Math.min(minutesAvailableForDay, totalTimeOffForDay);
			}

			// Append heatmap data from noAccessHeatMap
			const {noAccessHeatMaps} = data;
			let personHeatmapData = noAccessHeatMaps[person.id];
			if (!personHeatmapData) {
				personHeatmapData = [];
				noAccessHeatMaps[person.id] = personHeatmapData;
			}

			let relevantDataRange;
			for (let i = startDate; i <= endDate; i++) {
				// If we dont have a relevant date range yet, or the current date range's enddate is before our loop date "i"
				if (!relevantDataRange || (relevantDataRange[1] !== null && relevantDataRange[1] < i)) {
					// Find new relevant date range
					relevantDataRange = personHeatmapData.find(
						dataArray =>
							(dataArray[1] >= i && dataArray[0] === null) ||
							(dataArray[1] >= i && dataArray[0] <= i) ||
							(dataArray[1] === null && dataArray[0] <= i)
					);
				}
				if (relevantDataRange) {
					minutesAllocated += relevantDataRange[2];
					addToDistributionMap(btoa('NoAccess:-1'), relevantDataRange[2]);
					// Calc the persons minutes available for this day
					const minutesAvailableForDay = holidaysIncludingDaysOff.includes(i)
						? 0
						: personWorkingMinutes[dayData[i].isoWeekday - 1];
					minutesAvailable -= Math.min(relevantDataRange[3], minutesAvailableForDay); // Subtract timeoff from available. Limit to minutesAvailableForDay.
				}
			}

			// Available minutes cannot be less than zero
			minutesAvailable = Math.max(0, minutesAvailable);
			cachedItem = {minutesAllocated, minutesAvailable, distributionMap};
			this.heatmapCache.get(person.id).set(dateString, cachedItem);
		}
		return cachedItem;
	}

	composePersonHeatMapRow(group, stepDataArray, timelineStartDate, pixelsPerDay, timelineMinorStep) {
		const person = group.data;
		const personWorkingMinutes = [
			person.monday,
			person.tuesday,
			person.wednesday,
			person.thursday,
			person.friday,
			person.saturday,
			person.sunday,
		];
		const data = this.getData();

		const personCache = this.heatmapCache.get(person.id);
		if (!personCache?.needsRecalculation) {
			this.initializeHeatmapCache(person, data, stepDataArray, timelineMinorStep);
		}

		const heatmapItems = [];

		const {holidaysExcludingDaysOff} = getHolidayDates(person, data, personWorkingMinutes);

		for (const stepData of stepDataArray) {
			let {startDate, endDate} = stepData;

			const heatMapData = this.getHeatMapData(group, stepDataArray, startDate, endDate, timelineMinorStep);

			if (
				(person.startDate !== null && person.startDate > endDate) ||
				(person.endDate !== null && person.endDate < startDate)
			) {
				heatmapItems.push(
					this.constructCanvasItem('freeday', {
						group,
						stepData,
						onClick: this.onHeatmapItemClick.bind(
							this,
							person,
							startDate,
							endDate,
							heatMapData.minutesAllocated,
							heatMapData.minutesAvailable,
							heatMapData.distributionMap
						),
					})
				);
			} else if (heatMapData.minutesAvailable <= 0 && heatMapData.minutesAllocated <= 0) {
				if (stepData.isWeekend || (timelineMinorStep === 'day' && holidaysExcludingDaysOff.includes(startDate))) {
					// if the date is weekend or it is a public holiday show the freeday item
					heatmapItems.push(
						this.constructCanvasItem('freeday', {
							group,
							stepData,
							onClick: this.onHeatmapItemClick.bind(
								this,
								person,
								startDate,
								endDate,
								heatMapData.minutesAllocated,
								heatMapData.minutesAvailable,
								heatMapData.distributionMap
							),
						})
					);
				} else {
					// if not weekend nor freeday its timeoff
					heatmapItems.push(
						this.constructCanvasItem('timeoff', {
							group,
							stepData,
							onClick: this.onHeatmapItemClick.bind(
								this,
								person,
								startDate,
								endDate,
								heatMapData.minutesAllocated,
								heatMapData.minutesAvailable,
								heatMapData.distributionMap
							),
						})
					);
				}
			} else {
				heatmapItems.push(
					this.constructCanvasItem('utilization', {
						group,
						stepData,
						minutesAllocated: heatMapData.minutesAllocated,
						minutesAvailable: heatMapData.minutesAvailable,
						onClick: this.onHeatmapItemClick.bind(
							this,
							person,
							startDate,
							endDate,
							heatMapData.minutesAllocated,
							heatMapData.minutesAvailable,
							heatMapData.distributionMap
						),
					})
				);
			}
		}
		if (personCache) {
			personCache.needsRecalculation = false;
		}

		return heatmapItems;
	}

	composePersonGroupUtilizationRow(group, stepDataArray, timelineStartDate, pixelsPerDay, timelineMinorStep) {
		const items = [];
		let isInActualMode =
			!this.getData().company.isUsingSchedulingPlanMode && !this.getData().company.isUsingProjectAllocation;

		const {holidayCalendars, holidayCalendarEntries, company, persons, noAccessHeatMaps, timeRegistrations} =
			this.getData();

		if (this.isCalculationSwitched) {
			isInActualMode = !isInActualMode;
		}

		const personGroups = group.groups;
		const personIds = personGroups.filter(group => !group.filtered).map(group => group.id);
		const filteredPersons = persons.filter(person => personIds.includes(person.id));

		//Can't pass whole item array because web worker can't parse functions
		const earliestStartDate = stepDataArray[0].startDate;
		const latestEndDate = stepDataArray[stepDataArray.length - 1].endDate;
		// TODO: strippedItems should be cached using personIds as key - cache should be invalidated when moving items though so it is not trivial
		const strippedItems = this.state.items
			.filter(
				item =>
					!(item.startDate > latestEndDate || item.endDate < earliestStartDate) &&
					item.groupId &&
					personIds.some(personId => item.groupId.includes(personId))
			)
			.map(item => {
				return {
					groupId: item.groupId,
					startDate: item.startDate,
					endDate: item.endDate,
					itemType: item.itemType,
					data: {
						isHoliday: item.data.isHoliday,
						allocation: item.data.allocation,
						minutesRegistered: item.data.minutesRegistered,
						taskId: item.data.taskId,
						projectId: item.data.projectId,
						task: item.data.task,
						taskStartDate: item.data.taskStartDate,
						taskEndDate: item.data.taskEndDate,
						isHourEstimated: item.data.isHourEstimated,
						minutesPerEstimationPoint: item.data.minutesPerEstimationPoint,
						isIdleTimeInternal: item.data.isIdleTimeInternal,
					},
				};
			});

		const strippedData = {
			persons: filteredPersons,
			holidayCalendars,
			holidayCalendarEntries,
			company,
			noAccessHeatMaps,
			timeRegistrations,
		};

		for (const stepData of stepDataArray) {
			let {startDate, endDate} = stepData;
			const dateString = `${timelineMinorStep}-${startDate}-${isInActualMode}`;
			const cacheKey = `${group.id}-${dateString}`;
			let cachedData = this.personGroupUtilizationCache.get(cacheKey);
			items.push(
				new PersonGroupUtilizationItem({
					y: group.screenY,
					x: stepData.position,
					width: stepData.width,
					minutesAllocated: cachedData ? cachedData.minutesAllocated : 0,
					minutesAvailable: cachedData ? cachedData.minutesAvailable : 0,
					isPast: endDate < this.state.todayDate,
					isInActualMode: isInActualMode,
					dateString: dateString,
					cacheKey: cacheKey,
				})
			);
			if (this.isUsingNewTRU) {
				this.calculatePersonGroupUtilization(dateString, cacheKey, strippedData.persons, items);
			} else {
				if (!cachedData || cachedData.needsRecalculation) {
					const groupUtilization = calculatePersonGroupUtilization({
						startDate,
						endDate,
						data: strippedData,
						items: strippedItems,
						todayDate: this.state.todayDate,
						isInActualMode,
						dateString,
						MIN_DATE_YEAR,
						ITEM_TYPE,
						personIds,
						dayDataLight: this.props.dayDataLight,
					});
					cachedData = {
						minutesAllocated: groupUtilization.minutesAllocated,
						minutesAvailable: groupUtilization.minutesAvailable,
						needsRecalculation: false,
					};
					this.personGroupUtilizationCache.set(cacheKey, cachedData);
				}
			}
		}
		return items;
	}

	composeCompanyUtilizationRow(group, stepDataArray, timelineStartDate, pixelsPerDay, timelineMinorStep) {
		const items = [];
		let isInActualMode =
			!this.getData().company.isUsingSchedulingPlanMode && !this.getData().company.isUsingProjectAllocation;
		const {holidayCalendars, holidayCalendarEntries, company, persons, noAccessHeatMaps, timeRegistrations} =
			this.getData();

		if (this.isCalculationSwitched) {
			isInActualMode = !isInActualMode;
		}

		const personGroups = getPersonGroups(this.state.groups);
		const personIds = personGroups.filter(group => !group.filtered).map(group => group.id);
		const filteredPersons = persons.filter(person => personIds.includes(person.id));

		//Can't pass whole item array because web worker can't parse functions
		const earliestStartDate = stepDataArray[0].startDate;
		const latestEndDate = stepDataArray[stepDataArray.length - 1].endDate;
		// TODO: strippedItems should be cached using personIds as key - cache should be invalidated when moving items though so it is not trivial
		const strippedItems = this.state.items
			.filter(
				item =>
					!(item.startDate > latestEndDate || item.endDate < earliestStartDate) &&
					item.groupId &&
					personIds.some(personId => item.groupId.includes(personId))
			)
			.map(item => {
				return {
					groupId: item.groupId,
					startDate: item.startDate,
					endDate: item.endDate,
					itemType: item.itemType,
					data: {
						isHoliday: item.data.isHoliday,
						allocation: item.data.allocation,
						minutesRegistered: item.data.minutesRegistered,
						taskId: item.data.taskId,
						projectId: item.data.projectId,
						task: item.data.task,
						taskStartDate: item.data.taskStartDate,
						taskEndDate: item.data.taskEndDate,
						isHourEstimated: item.data.isHourEstimated,
						minutesPerEstimationPoint: item.data.minutesPerEstimationPoint,
						isIdleTimeInternal: item.data.isIdleTimeInternal,
					},
				};
			});

		const strippedData = {
			persons: filteredPersons,
			holidayCalendars,
			holidayCalendarEntries,
			company,
			noAccessHeatMaps,
			timeRegistrations,
		};

		for (const stepData of stepDataArray) {
			let {startDate, endDate} = stepData;
			const dateString = `${timelineMinorStep}-${startDate}-${isInActualMode}`;
			const cachedData = this.companyUtilizationCache.get(dateString);
			items.push(
				new CompanyUtilizationItem({
					y: group.screenY,
					x: stepData.position,
					width: stepData.width,
					minutesAllocated: cachedData ? cachedData.minutesAllocated : 0,
					minutesAvailable: cachedData ? cachedData.minutesAvailable : 0,
					isPast: endDate < this.state.todayDate,
					isInActualMode: isInActualMode,
					dateString: dateString,
				})
			);
			if (this.isUsingNewTRU) {
				this.calculateCompanyUtilization(dateString, strippedData.persons, items);
			} else {
				if (!cachedData || cachedData.needsRecalculation) {
					const currentCacheValue = this.companyUtilizationCache.get(dateString);
					this.companyUtilizationCache.set(dateString, {
						minutesAllocated: currentCacheValue ? currentCacheValue.minutesAllocated : 0,
						minutesAvailable: currentCacheValue ? currentCacheValue.minutesAvailable : 0,
						needsRecalculation: false,
					});
					//postMessage can take a noticeable amount of time if you have a lot of data so we delay it slightly to let other drag-end code resolve first
					setTimeout(() => {
						this.companyUtilizationWebWorker.postMessage({
							startDate,
							endDate,
							data: strippedData,
							items: strippedItems,
							todayDate: this.state.todayDate,
							isInActualMode,
							dateString,
							MIN_DATE_YEAR,
							ITEM_TYPE,
							personIds,
							dayDataLight: this.props.dayDataLight,
						});
					}, 200);
				}
			}
		}
		return items;
	}

	calculatePersonGroupUtilization(dateString, cacheKey, persons, items) {
		let minutesAllocated = 0;
		let minutesAvailable = 0;
		persons.forEach(person => {
			const personCache = this.heatmapCache.get(person.id);
			if (personCache) {
				const sectionCache = personCache.get(person.id + '-' + dateString);
				if (sectionCache) {
					minutesAllocated += sectionCache.minutesAllocated;
					minutesAvailable += sectionCache.minutesAvailable;
				}
			}
		});
		this.personGroupUtilizationCache.set(cacheKey, {minutesAllocated, minutesAvailable, needsRecalculation: false});
		const utilizationItem = items.find(item => item.data.cacheKey === cacheKey);
		utilizationItem.data.minutesAllocated = minutesAllocated;
		utilizationItem.data.minutesAvailable = minutesAvailable;
	}

	calculateCompanyUtilization(dateString, persons, items) {
		let minutesAllocated = 0;
		let minutesAvailable = 0;
		persons.forEach(person => {
			const personCache = this.heatmapCache.get(person.id);
			if (personCache) {
				const sectionCache = personCache.get(person.id + '-' + dateString);
				if (sectionCache) {
					minutesAllocated += sectionCache.minutesAllocated;
					minutesAvailable += sectionCache.minutesAvailable;
				}
			}
		});
		this.companyUtilizationCache.set(dateString, {minutesAllocated, minutesAvailable, needsRecalculation: false});
		const utilizationItem = items.find(item => item.data.dateString === dateString);
		utilizationItem.data.minutesAllocated = minutesAllocated;
		utilizationItem.data.minutesAvailable = minutesAvailable;
	}

	onHeatmapItemClick(person, startDate, endDate, minutesAllocated, minutesAvailable, distributionMap) {
		const {
			viewer,
			projects,
			projectGroups,
			projectPersons,
			idleTimes,
			persons,
			company,
			holidayCalendarEntries,
			holidayCalendars,
			phases,
			roles,
			teams,
			teamPersons,
		} = this.getData() ? this.getData() : this.state.lightWeightData;

		showModal({
			type: MODAL_TYPE.STANDALONE_CANVAS_UTILIZATION,
			startDate,
			endDate,
			person,
			company,
			projects,
			projectGroups,
			persons,
			projectPersons,
			holidayCalendars,
			holidayCalendarEntries,
			actualPersonId: viewer.actualPersonId,
			availableFeatureFlags: viewer.availableFeatureFlags,
			idleTimes,
			minutesAvailable,
			readOnly: false,
			milestones: phases,
			roles,
			teams,
			teamPersons,
			isPast: endDate < this.state.todayDate,
		});

		tracking.trackEvent('Open Utilization Modal');
	}

	getUnassignedTaskCount() {
		const data = this.getData();
		if (!data || !data.tasks) {
			return 0;
		}
		if (this.cachedUnassignedTasksCount === undefined) {
			// filter the tasks that are not assigned to anybody, not done and that belong to a project that is not HALTED or DONE
			this.cachedUnassignedTasksCount = data.tasks.filter(task => {
				return (
					task.startYear != null &&
					task.deadlineYear != null &&
					task.assignedPersons.length === 0 &&
					task.done === false &&
					data.projects.find(project => {
						return (
							project.id === task.projectId &&
							![PROJECT_STATUS.HALTED, PROJECT_STATUS.DONE].includes(project.status)
						);
					}) &&
					(hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL) ||
						data.projectPersons.find(
							projectPerson =>
								projectPerson.personId === data.viewer.actualPersonId &&
								projectPerson.projectId === task.projectId
						)) &&
					this.state.filterFunctions.taskFilter(this.getTaskFilterData(task))
				);
			}).length;
		}
		return this.cachedUnassignedTasksCount;
	}

	scroll(value) {
		this.timeline.scroll(value, {applyEasing: true});
	}

	scrollToToday() {
		this.timeline.scrollToToday(0.25);
	}

	handleMoveDateButtonClick(moveForward) {
		if (moveForward) {
			this.scroll(0.33);
		} else {
			this.scroll(-0.33);
		}
	}

	onSearchChange(e) {
		//new navigation returns string in parameter
		const value = e.target ? e.target.value : e;
		this.clearCompanyUtilizationCache();
		this.setState({searchFilterValue: value}, () => {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
		});
	}

	onTimelineVerticalScroll(delta) {
		if (this.state.showExpandedActionMenu) {
			this.setState({showExpandedActionMenu: false});
		}
		if (this.state.contextMenuOptions) {
			this.setState({contextMenuX: null, contextMenuY: null, contextMenuOptions: null});
		}
	}

	onTimelineHorizontalScroll(delta) {
		if (this.state.showExpandedActionMenu) {
			this.setState({showExpandedActionMenu: false});
		}
		if (this.state.contextMenuOptions) {
			this.setState({contextMenuX: null, contextMenuY: null, contextMenuOptions: null});
		}
	}

	onTimelineRangeChange(startDate, endDate) {
		if (this.isItemGenerationComplete) return;
		const startDateStep = this.getDateRelevancyStep(startDate);
		while (!this.currentItemCreationGeneratorStep || startDateStep <= this.currentItemCreationGeneratorStep) {
			const generatorResult = this.itemGenerator.next();
			if (generatorResult.done) {
				this.isItemGenerationComplete = true;
				break;
			}
		}
	}

	getDateRelevancyStep(canvasTimelineDate) {
		return Math.floor(canvasTimelineDate / 32);
	}

	onPersonImageLoad() {
		if (this.personImageLoadTimeout) {
			clearTimeout(this.personImageLoadTimeout);
			this.personImageLoadTimeout = null;
		}
		this.personImageLoadTimeout = setTimeout(() => {
			dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {
				preventFiltering: true,
				isInitialLoad: true,
				preventHeatmapCalculation: true,
			});
		}, 500);
	}

	onFilterChange(filterValues, filterFunctions) {
		this.clearCompanyUtilizationCache();
		if (filterValues) {
			const filterLocalStorageString = `canvas-scheduling-filters-v4-people`;
			Util.localStorageSetItem(filterLocalStorageString, JSON.stringify(filterValues));
			this.getFilterData().roles.forEach(role => {
				if (this.heatmapCache.get(role.id)) {
					this.heatmapCache.get(role.id).needsRecalculation = true;
				}
			});
			this.setState({filters: filterValues, filterFunctions: filterFunctions}, () => {
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: false});
			});
		}
	}

	filterPersonGroupingGroupV4(group, stepDataArray, startDate, pixelsPerDay, timelineMinorStep, canvasWidth) {
		let visibleChildren = false;

		for (const childGroup of group.groups) {
			childGroup.filtered = this.filterPersonGroupV4(
				childGroup,
				stepDataArray,
				startDate,
				pixelsPerDay,
				timelineMinorStep,
				canvasWidth
			);
			if (!childGroup.filtered) {
				visibleChildren = true;
			}
		}
		return !visibleChildren;
	}

	filterPersonGroupV4(group, stepDataArray, startDate, pixelsPerDay, timelineMinorStep, canvasWidth) {
		let visibleByFilter = true;

		if (this.state && this.state.filterFunctions && this.state.filters) {
			// CAPACITY WORKLOAD FILTER
			let workloadArray = []; // array that contains the workload capacity for each step in the canvas
			if (this.state.filters?.person?.capacityWorkload) {
				const addToWorkloadArray = (minutesAllocated, minutesAvailable) => {
					const isNotAllocated = minutesAllocated === 0;
					const isBookedInStep = minutesAllocated > 0;
					const isAvailable = minutesAvailable > 0;
					const isOverallocated = minutesAllocated > minutesAvailable;
					const isWithinCheckmarkRange = isOverallocated
						? minutesAllocated / minutesAvailable - 1 < HEATMAP_CHECKMARK_LENIENCY_PERCENTAGE / 100
						: minutesAllocated / minutesAvailable - 1 > -HEATMAP_CHECKMARK_LENIENCY_PERCENTAGE / 100;

					if (isOverallocated && !isWithinCheckmarkRange) {
						workloadArray.push('overbooked');
					}
					if (isAvailable && !isOverallocated && !isWithinCheckmarkRange) {
						workloadArray.push('underbooked');
					}
					if (isWithinCheckmarkRange) {
						workloadArray.push('fullybooked');
					}
					if (isBookedInStep) {
						workloadArray.push('booked');
					}
					if (isNotAllocated && isAvailable) {
						workloadArray.push('noworkload');
					}
				};

				if (!this.heatmapCache.has(group.data.personId) && this.getFilterData().heatMaps) {
					this.composePersonHeatMapRow(group, stepDataArray, startDate, pixelsPerDay, timelineMinorStep);
				}

				for (const stepData of stepDataArray) {
					if (isStepHiddenByLoadMore(this, stepData)) continue;

					let {startDate: stepDataStartDate, endDate: stepDataEndDate} = stepData;
					const heatMapData = this.getHeatMapData(
						group,
						stepDataArray,
						stepDataStartDate,
						stepDataEndDate,
						timelineMinorStep
					);
					const {minutesAllocated, minutesAvailable} = heatMapData;
					addToWorkloadArray(minutesAllocated, minutesAvailable);
				}
			}

			// ALOCATED TO
			let allocatedToIds = [];
			if (
				this.state.filters.person &&
				((this.state.filters.person.project && this.state.filters.person.project.length > 0) ||
					(this.state.filters.person.internalTime && this.state.filters.person.internalTime.length > 0) ||
					(this.state.filters.person.timeOff && this.state.filters.person.timeOff.length > 0))
			) {
				// only do this if there are any relevant filters added to make it more efficient
				const endDate = startDate + canvasWidth / pixelsPerDay;
				const projectItemsAndIdle = this.state.items.filter(item => {
					if (item.itemType !== ITEM_TYPE.PEOPLE_SCHEDULING_PROJECT_ALLOCATION) {
						return false;
					}
					const {personId} = item.data.allocation;
					return group.id === personId && !(item.startDate > endDate || item.endDate < startDate - 1);
				});
				// Check task allocation projects
				const taskAllocationProjectIds = group.groups
					.filter(
						projectGroup =>
							projectGroup.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PROJECT &&
							!projectGroup.data.useManualAllocations
					)
					.map(projectGroup => projectGroup.id + '-task');
				const taskItems = this.state.items.filter(
					item =>
						item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK &&
						!(item.startDate > endDate || item.endDate < startDate - 1) &&
						!item.groupId.includes('unassignedtask') &&
						taskAllocationProjectIds.includes(`${item.groupId}-task`)
				);

				allocatedToIds = [
					...projectItemsAndIdle.map(item => {
						const {projectId, projectGroupId, idleTimeId} = item.data.allocation;
						// return id based on the allocation type. It could be project, projectgroup or idle time
						return projectId || projectGroupId || idleTimeId;
					}),
					...taskItems.map(t => t.data.allocation.projectId),
				];
			}

			// LABELS
			const personLabelsForPerson = this.getFilterData().personLabelByPersonMap[group.id] || [];
			const labels = personLabelsForPerson.map(pl => ({label: {...pl, id: pl.labelId}}));

			// SKILLS
			const personSkillsForPerson = this.getFilterData().personSkillsByPersonMap[group.id] || [];
			const skills = personSkillsForPerson.map(ps => ({skill: {...ps}}));

			const projectPeriodsForPerson = this.getFilterData().projectPersonByPersonMap[group.id] || [];
			const personProjects = projectPeriodsForPerson.map(entry => ({id: entry.projectId}));

			// DEPARTMENT
			const departmentId = group.data.departmentId ? btoa(`DepartmentType:${group.data.departmentId}`) : undefined;

			const personGroup = {
				id: group.data.id,
				permissionLevel: group.data.permissionLevel,
				departmentId,
				role: {id: group.data.roleId},
				projects: personProjects,
				allocatedToIds,
				workloadArray: _.uniq(workloadArray),
				personLabels: {edges: labels},
				personSkills: skills,
			};

			const options = {
				teams: this.getFilterData().teamsRelay,
			};
			visibleByFilter = this.state.filterFunctions.personFilter(personGroup, options);
		}

		// Search
		const {searchFilterValue} = this.state;
		let visibleBySearch = true;
		if (searchFilterValue && searchFilterValue.length) {
			visibleBySearch = Util.normalizedIncludes(group.data.name + group.data.roleName, searchFilterValue);
		}

		return !visibleByFilter || !visibleBySearch;
	}

	filterProjectGroupsV4(items, personGroups) {
		if (this.state.filterFunctions) {
			for (const personGroup of personGroups) {
				let filteredGroups = []; // will contain the project groups that are filtered. Will be used to hide items that belong to the project

				for (const group of personGroup.groups) {
					if (group.data.id) {
						if (group.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PROJECT) {
							const projectId = group.data.id.replace(`${group.data.personId}-`, '');
							const isGroupFiltered = this.isProjectFiltered(projectId);

							if (isGroupFiltered) filteredGroups.push(group);

							group.filtered = isGroupFiltered;
						} else if (group.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PERSON_ALLOCATIONS) {
							// if project grouping is disabled filter the items that belong to a filtered group
							for (const filteredGroup of filteredGroups) {
								const groupItems = items.filter(item => item.groupId === filteredGroup.data.id);

								if (groupItems) {
									for (const item of groupItems) {
										item.filtered = filteredGroup.filtered;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	isProjectFiltered(projectId) {
		let budgetType;
		let assignedPersons = [];
		let currentProjectStatus;
		let projectPersons = {};
		let projectLabels = [];
		const isConnectedProject = atob(projectId).startsWith('ProjectGroup');
		let project;

		if (isConnectedProject) {
			project = this.getFilterData().projectGroupMap.get(projectId);
			const subProjects = this.getFilterData().projectByProjectGroupMap[projectId] || [];
			if (subProjects.length > 0) {
				const subProjectsIds = subProjects.map(p => p.id);
				const firstProjectId = subProjectsIds[0];

				budgetType = subProjects.map(p => p.budgetType);
				const projectPersonsOnProject = this.getFilterData().projectPersonByProjectMap[firstProjectId] || [];
				assignedPersons = projectPersonsOnProject.map(pp => ({id: pp.personId}));
				currentProjectStatus = _.uniq(
					subProjectsIds
						.map(projectId => this.getFilterData().projectStatusMap.get(projectId))
						.filter(projectStatus => projectStatus)
				);
				projectPersons = {
					edges: projectPersonsOnProject.map(pp => ({
						node: {isContactPerson: pp.isContactPerson, person: {id: pp.personId}},
					})),
				};
				projectLabels = {
					edges: _.uniq(
						_.flatten(
							subProjectsIds.map(projectId => this.getFilterData().projectLabelByProjectMap[projectId] || [])
						)
					).map(pl => ({node: {label: {id: pl.labelId}}})),
				};
			}
		} else {
			project = this.getFilterData().projectMap.get(projectId);

			budgetType = project.budgetType;
			const projectPersonsOnProject = this.getFilterData().projectPersonByProjectMap[project.id] || [];
			assignedPersons = projectPersonsOnProject.map(pp => ({id: pp.personId}));
			currentProjectStatus = this.getFilterData().projectStatusMap.get(project.id);
			projectPersons = {
				edges: projectPersonsOnProject.map(pp => ({
					node: {isContactPerson: pp.isContactPerson, person: {id: pp.personId}},
				})),
			};
			const projectLabelsOnProject = this.getFilterData().projectLabelByProjectMap[project.id] || [];
			projectLabels = {
				edges: projectLabelsOnProject.map(pl => ({node: {label: {id: pl.labelId}}})),
			};
		}

		const groupFilterData = {
			isIdleTime: false,
			budgetType,
			project: {...project, id: projectId, client: {id: project.clientId}},
			assignedPersons,
			currentProjectStatus,
			projectPersons,
			projectLabels,
		};
		return !this.state.filterFunctions.projectFilter(groupFilterData);
	}

	getTaskFilterData(task) {
		// maps data to match the structure the filter expects
		const statusColumn = this.getFilterData().statusColumnMap.get(task.statusColumnId);
		const ownerId = task.ownerId ? task.ownerId : null;
		const taskLabelsOnTask = task.taskLabels || [];
		const taskLabels = taskLabelsOnTask.map(label => ({label: {id: label.labelId}}));
		const followers = task.followers ? task.followers.map(fId => ({id: fId})) : [];

		return {
			role: {
				id: task.roleId,
			},
			statusColumnV2: {
				category: statusColumn && statusColumn.category ? statusColumn.category : null,
			},
			project: {
				id: task.projectId,
			},
			owner: {id: ownerId},
			followers,
			latestUiUpdateAt: task.latestUiUpdateAt,
			taskLabels,
			bug: task.bug,
			blocked: task.blocked,
			hasDependency: task.hasDependency,
			highPriority: task.highPriority,
			billable: task.billable,
			favoured: task.favoured,
		};
	}

	getAllocationFilterData(allocation) {
		// maps data to match the structure the filter expects
		return {
			...allocation,
			idleTime: allocation.idleTimeId
				? {
						id: allocation.idleTimeId,
				  }
				: undefined,
			project: allocation.projectId
				? {
						id: allocation.projectId,
				  }
				: undefined,
			projectGroup: allocation.projectGroupId
				? {
						id: allocation.projectGroupId,
				  }
				: undefined,
		};
	}

	filterTaskAndAllocationItems(items, isParentGroupFiltered) {
		const {filters: appliedFilters} = this.state;
		for (const item of items) {
			if (item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK) {
				if (
					appliedFilters &&
					appliedFilters.project &&
					(appliedFilters.project.internalTime || appliedFilters.project.timeOff)
				) {
					// Have actively decided that when an internal time or timeoff filter is applied, everything else should be hidden
					item.filtered = true;
				} else {
					const {task} = item.data;
					let taskItemFilterData = this.getTaskFilterData(task);

					item.filtered = !this.state.filterFunctions.taskFilter(taskItemFilterData);
				}
			} else {
				const {allocation} = item.data;
				let allocationItemData = allocation ? this.getAllocationFilterData(allocation) : {};

				item.filtered = !this.state.filterFunctions.allocationFilter(allocationItemData);
			}
			item.filtered = item.filtered || isParentGroupFiltered(item);
		}
	}

	filterItemsV4(items, groups) {
		if (this.state.filterFunctions && this.state.filterFunctions.allocationFilter) {
			if (this.isProjectGroupingDisabled()) {
				const groupMap = {};
				for (const personGroup of groups) {
					if (personGroup.groups) {
						for (const group of personGroup.groups) {
							groupMap[group.id] = group;
						}
					}
				}
				const isParentGroupFiltered = item => groupMap[item.groupId]?.filtered || false;
				this.filterTaskAndAllocationItems(items, isParentGroupFiltered);
			} else {
				const itemsByGroupId = _.groupBy(items, 'groupId');

				// go through each group whe project grouping is enabled because we want to be able and hide the project group too
				for (const personGroup of groups) {
					if (personGroup.groups) {
						for (const group of personGroup.groups) {
							if (!group.filtered) {
								// it might seems counter intuitive that we are filtering the items to find all the items in a group but this works better because we have access to all the items. it seems like group.items does not contain all the items
								// const groupItems = group.items;
								const groupItems = itemsByGroupId[group.id] || [];
								if (groupItems) {
									this.filterTaskAndAllocationItems(groupItems, () => group.filtered);
									// if the group contains at least one item and all the items are filtered, hide the group. only filter project groups, and show the non project time
									group.filtered =
										group.groupType !== GROUP_TYPE.PEOPLE_SCHEDULING_NON_PROJECT_TIME &&
										groupItems.length > 0 &&
										groupItems.every(item => item.filtered);
								}
							}
						}
					}
				}
			}
		}
	}

	getAllocatedMinutes(
		personHeatMapData,
		holidaysIncludingDaysOff,
		personWorkingMinutes,
		dayData,
		minutesAllocated,
		minutesAvailable,
		overallStartDate,
		overallEndDate,
		person
	) {
		let heatmapDataStartDate, heatmapDataEndDate, heatmapDataMinutesAllocated, heatmapDataMinutesTimeOff;
		const startDate = person.startDate ? Math.max(overallStartDate, person.startDate) : overallStartDate;
		const endDate = person.endDate ? Math.min(overallEndDate, person.endDate) : overallEndDate;
		for (let i = startDate; i <= endDate; i++) {
			// If we dont have a relevant date range yet, or the current date range's enddate is before our loop date "i"
			if ((!heatmapDataStartDate && !heatmapDataEndDate) || (heatmapDataEndDate !== null && heatmapDataEndDate < i)) {
				// Find new relevant date range
				const foundHeatMap = personHeatMapData.find(
					dataArray =>
						(dataArray[1] >= i && dataArray[0] === null) ||
						(dataArray[1] >= i && dataArray[0] <= i) ||
						(dataArray[1] === null && dataArray[0] <= i)
				);
				if (foundHeatMap) {
					[heatmapDataStartDate, heatmapDataEndDate, heatmapDataMinutesAllocated, heatmapDataMinutesTimeOff] =
						foundHeatMap;
				}
			}
			if (heatmapDataStartDate || heatmapDataEndDate) {
				minutesAllocated += heatmapDataMinutesAllocated;
				// Calc the persons minutes available for this day
				const minutesAvailableForDay = holidaysIncludingDaysOff.includes(i)
					? 0
					: personWorkingMinutes[dayData[i].isoWeekday - 1];
				minutesAvailable -= Math.min(heatmapDataMinutesTimeOff, minutesAvailableForDay); // Subtract timeoff from available. Limit to minutesAvailableForDay.
			}
		}

		return [minutesAllocated, minutesAvailable];
	}

	initializeHeatmapCache(person, data, stepDataArray, timelineMinorStep) {
		const personWorkingHours = {
			monday: person.monday,
			tuesday: person.tuesday,
			wednesday: person.wednesday,
			thursday: person.thursday,
			friday: person.friday,
			saturday: person.saturday,
			sunday: person.sunday,
		};
		const personWorkingMinutes = [
			person.monday,
			person.tuesday,
			person.wednesday,
			person.thursday,
			person.friday,
			person.saturday,
			person.sunday,
		];
		const personHeatMapData = data.heatMaps[person.id];
		if (!personHeatMapData) return;
		const {holidaysIncludingDaysOff} = getHolidayDates(person, data, personWorkingMinutes);
		const {dayData} = this.props;
		let isInActualMode = !data.company.isUsingSchedulingPlanMode && !data.company.isUsingProjectAllocation;
		if (this.isCalculationSwitched) {
			isInActualMode = !isInActualMode;
		}

		if (!this.heatmapCache.has(person.id)) {
			this.heatmapCache.set(person.id, new Map());
		}
		const personCache = this.heatmapCache.get(person.id);
		for (const stepData of stepDataArray) {
			let minutesAllocated = 0;
			let {startDate, endDate} = stepData;
			const dateString = `${person.id}-${timelineMinorStep}-${startDate}-${isInActualMode}`;
			let cachedItem = personCache.get(dateString);
			if (cachedItem) continue;
			if ((person.startDate && endDate < person.startDate) || (person.endDate && startDate > person.endDate)) {
				continue;
			}

			const weekdaysInPeriod = getWeekdaysBetweenDates(startDate, endDate);
			for (const holidayDate of holidaysIncludingDaysOff.filter(date => date >= startDate && date <= endDate)) {
				weekdaysInPeriod[dayData[holidayDate].isoWeekday - 1]--;
			}
			for (let canvasDate = startDate; canvasDate <= endDate; canvasDate++) {
				if (!isDateWithinPersonStartEndDate(person, canvasDate)) {
					weekdaysInPeriod[dayData[canvasDate].isoWeekday - 1] = Math.max(
						weekdaysInPeriod[dayData[canvasDate].isoWeekday - 1] - 1,
						0
					);
				}
			}
			let minutesAvailable = getMinutesInWeekdays(personWorkingHours, weekdaysInPeriod);

			[minutesAllocated, minutesAvailable] = this.getAllocatedMinutes(
				personHeatMapData,
				holidaysIncludingDaysOff,
				personWorkingMinutes,
				dayData,
				minutesAllocated,
				minutesAvailable,
				startDate,
				endDate,
				this.state.todayDate,
				isInActualMode,
				person
			);
			minutesAvailable = Math.max(minutesAvailable, 0); // Available may never be negative

			personCache.set(dateString, {minutesAllocated, minutesAvailable});
		}
	}

	filterUnassignedTaskGroupsV4(items, groups) {
		if (this.state.filterFunctions && this.state.filterFunctions.taskFilter) {
			for (const unassignedRoleGroup of groups) {
				for (const unassignedRoleTaskGroup of unassignedRoleGroup.groups) {
					const isParentGroupFiltered = item => {
						return (
							unassignedRoleGroup.filtered ||
							unassignedRoleTaskGroup.filtered ||
							this.isProjectFiltered(item.data.parentId) ||
							false
						);
					};
					const itemsInGroup = items.filter(item => item.groupId === unassignedRoleTaskGroup.id);
					this.filterTaskAndAllocationItems(itemsInGroup, isParentGroupFiltered);
				}
			}
		}
	}

	isPersonGroupBookedInPeriod(group, startDate, endDate) {
		// Look through items and se if any of the relevant ones are within the timeframe
		const {items} = this.state;
		let groupIds = [];
		if (group.groups) {
			for (let i = 0; i < group.groups.length; i++) {
				const subGroup = group.groups[i];
				if (
					!subGroup.filtered &&
					(subGroup.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_PROJECT ||
						subGroup.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_NON_PROJECT_TIME)
				) {
					groupIds.push(subGroup.id);
					if (subGroup.groups) {
						for (let j = 0; j < subGroup.groups.length; j++) {
							const subsubGroup = subGroup.groups[j];
							if (!subsubGroup.filtered && subsubGroup.groupType === GROUP_TYPE.PEOPLE_SCHEDULING_TASK) {
								groupIds.push(subsubGroup.id);
							}
						}
					}
				}
			}
		}

		for (let i = 0; i < items.length; i++) {
			const item = items[i];
			if (
				!item.filtered &&
				!(item.startDate > endDate || item.endDate < startDate - 1) &&
				groupIds.includes(item.groupId)
			) {
				return false;
			}
		}

		return true;
	}

	resetRecalculateSteps() {
		this.setState({recalculateSteps: false});
	}

	handleGroupByChange = value => {
		this.setState(
			{
				peopleSchedulingOptions: {...this.state.peopleSchedulingOptions, groupBy: value},
			},
			() => {
				localStorage.setItem('peopleScheduling_groupBy', value);
				if (this.state.data) {
					this.resetState(this.props, this.state.data);
				} else {
					this.doFetchFullData(this.props, false);
				}
			}
		);
	};

	handleUtilizationFormatChange = value => {
		this.setState(
			{
				peopleSchedulingOptions: {...this.state.peopleSchedulingOptions, utilizationFormat: value},
			},
			() => {
				localStorage.setItem('peopleScheduling_utilizationFormat', value);
				dispatch(EVENT_ID.CANVAS_TIMELINE_FORCE_REDRAW, {preventFiltering: true, isInitialLoad: false});
			}
		);
	};

	setPreventFiltering(preventFiltering) {
		this.setState({preventFiltering});
	}

	filterItems() {
		const {items, groups, collapsableSectionGroups} = this.state;
		const personGroups = getPersonGroups(groups);
		this.filterUnassignedTaskGroupsV4(items, collapsableSectionGroups);
		this.filterProjectGroupsV4(items, personGroups);
		this.filterItemsV4(items, personGroups);
	}

	render() {
		if (!this.state.dataLoaded) {
			return (
				<div key={'c1'} className="canvas-scheduling">
					<div className="is-loading" />
				</div>
			);
		}

		const {
			data,
			lightWeightData,
			groups,
			collapsableSectionGroups,
			items,
			showCollapsedActionMenu,
			collapsedActionMenuY,
			showExpandedActionMenu,
			expandedActionMenuY,
			expandedActionMenuData,
			expandedActionMenuType,
			showArrowClickableArea,
			arrowClickableAreaY,
			collapsedActionMenuData,
			showDetailBox,
			detailBoxX,
			detailBoxY,
			detailBoxData,
			peopleSchedulingDetailSelectorOptions,
			recalculateSteps,
			contextMenuX,
			contextMenuY,
			contextMenuOptions,
			splitAllocationBarData,
			preventFiltering,
		} = this.state;

		const isUsingProjectAllocation = data
			? data.company.isUsingProjectAllocation
			: lightWeightData.company.isUsingProjectAllocation;

		const isCollapsableSectionExpanded =
			(isUsingProjectAllocation ||
				this.state.peopleSchedulingDetailSelectorOptions.find(option => option.name === 'unassigned-tasks')?.checked) &&
			this.state.isCollapsableSectionExpanded;
		const {dayData, startDate} = this.props;

		let holidaysEntriesCanvasFormat = [];

		// in the new desgin the holidays maked with the diagonal lines pattern from the top of the canvas to the bottom is the default calendar. if there is no default calendar only weekends will have the pattern
		const defaultHolidayCalendarEntries = data
			? data.holidayCalendarEntries.filter(entry => entry.holidayCalendarId === data.company.defaultHolidayCalendarId)
			: [];
		holidaysEntriesCanvasFormat = data
			? defaultHolidayCalendarEntries.map(entry => createCanvasTimelineDate(entry.year, entry.month, entry.day))
			: [];

		const {formatMessage} = this.props.intl;
		if (!preventFiltering) {
			this.filterItems();
		}

		const unassignedEyeOption = this.state.peopleSchedulingDetailSelectorOptions.find(
			option => option.name === 'unassigned-tasks'
		);
		const topLeftComponent =
			isUsingProjectAllocation ||
			!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS) ||
			(unassignedEyeOption && !unassignedEyeOption.checked) ? (
				<div className="unassigned-section-controller collaborator" data-userpilot={'schedule-unassigned-section'} />
			) : (
				<div
					className="unassigned-section-controller"
					data-userpilot={'schedule-unassigned-section'}
					onClick={() => {
						this.setState({isCollapsableSectionExpanded: !isCollapsableSectionExpanded});
					}}
				>
					<div className={'group-expand-arrow ' + (isCollapsableSectionExpanded ? 'expanded' : '')} />
					<div className="task-count-text">{this.getUnassignedTaskCount()}</div>
					<div className="text-container">
						<div className="unassigned-text">{formatMessage({id: 'scheduling.unassigned_tasks'})}</div>
					</div>
				</div>
			);

		let width, height, top, left;
		if (this.timeline) {
			width = window.innerWidth;
			height = window.innerHeight - this.timeline.state.canvasOffsetTop;
			top = this.timeline.state.canvasOffsetTop;
			left = 0;
		}

		const findProjectPersons = (project, person) => {
			let projectIds = [project.id];
			if (project.companyProjectGroupId) {
				// If connected project, find the project ids of all connected projects
				projectIds = data.projectByProjectGroupMap[project.id].map(project => project.id);
			}
			return data.projectPersonByPersonMap[person.id]?.filter(projectPerson =>
				projectIds.includes(projectPerson.projectId)
			);
		};

		const actionOptions = (
			expandedActionMenuType === SCHEDULING_ACTION_MENU_TYPE.PROJECT
				? [
						{
							text: formatMessage({
								id: expandedActionMenuData.project.companyProjectGroupId
									? 'overview_projects.group_link'
									: 'scheduling.allocation_modal.view_project',
							}),
							onClick: () => {
								this.viewProject(
									!!expandedActionMenuData.project.companyProjectGroupId,
									expandedActionMenuData.project.companyProjectGroupId ||
										expandedActionMenuData.project.companyProjectId
								);
							},
						},
						hasPermission(PERMISSION_TYPE.PROJECT_PERSON_DELETE) &&
						hasFeatureFlag('project_person_management_in_schedule')
							? {
									text: formatMessage({
										id: 'scheduling.remove_from_project',
									}),
									onClick: () => {
										this.hideExpandedActionMenu();
										handleRemovePerson(
											expandedActionMenuData.project,
											expandedActionMenuData.person,
											findProjectPersons(expandedActionMenuData.project, expandedActionMenuData.person),
											formatMessage
										);
									},
							  }
							: null,
				  ]
				: expandedActionMenuType === SCHEDULING_ACTION_MENU_TYPE.PERSON &&
				  hasFeatureFlag('project_person_management_in_schedule') &&
				  hasPermission(PERMISSION_TYPE.PROJECT_PERSON_CREATE)
				? [
						{
							text: formatMessage({id: 'scheduling.add_to_project'}),
							onClick: () => {
								this.hideExpandedActionMenu();
								this.addPersonToProject(expandedActionMenuData.person);
							},
						},
				  ]
				: []
		).filter(Boolean);

		const filterGroupOnHorizontalScroll = new Set();
		const filterGroupOnZoom = new Set();

		if (hasFeatureFlag('people_scheduling_scroll_filter_workload') && this.state.filters?.person?.capacityWorkload) {
			filterGroupOnHorizontalScroll.add(GROUP_TYPE.PEOPLE_SCHEDULING_PERSON);
			filterGroupOnHorizontalScroll.add(GROUP_TYPE.PEOPLE_SCHEDULING_PERSON_GROUP);
			filterGroupOnZoom.add(GROUP_TYPE.PEOPLE_SCHEDULING_PERSON);
			filterGroupOnZoom.add(GROUP_TYPE.PEOPLE_SCHEDULING_PERSON_GROUP);
		}

		return (
			<>
				{this.state.initData.featureFlags.some(flag => flag.key === 'third_level_nav') && (
					<div style={{backgroundColor: '#fff'}}>
						<TopHeaderBarWrapper sidePadding={24} bottomPadding={0}>
							<TopHeaderBar
								title={this.props.intl.formatMessage({id: 'scheduling.menu.schedule_people'})}
								content={getTopHeaderContent(this)}
							/>
						</TopHeaderBarWrapper>
					</div>
				)}
				<div className="control-bar">{createHeader(this)}</div>
				<div
					className="canvas-people-scheduling"
					onClick={e => {
						//this.setState({showActionMenu: false, actionMenuExpanded: false});
					}}
				>
					<div className="hover-effects-container">
						{contextMenuX && contextMenuY && contextMenuOptions && contextMenuOptions.length ? (
							// we are setting the key to be the sum of the coordinates because this will cause a rerender of the context menu if the user right clicks on another item
							// solves the issue of the context menu not updating the position
							<ContextMenu
								key={contextMenuX + contextMenuY}
								cy="canvas-people-scheduling-context-menu"
								options={contextMenuOptions}
								contextMenuPosition={{x: contextMenuX, y: contextMenuY}}
							/>
						) : null}
						{showCollapsedActionMenu &&
						(!showExpandedActionMenu || collapsedActionMenuY !== expandedActionMenuY) ? (
							<>
								{collapsedActionMenuData.project?.companyProjectGroupId ? (
									<ProjectGroupInfoBox
										projects={data.projects.filter(
											project => project.projectGroupId === collapsedActionMenuData.project.id
										)}
										top={collapsedActionMenuY + 5}
									/>
								) : null}
								<div className="people-scheduling-actions-menu" style={{top: collapsedActionMenuY, left: GROUP_SECTION_ACTIONS_MENU_LEFT_SCHEDULE_PEOPLE()}}>
									<ActionMenu
										options={[]}
										onExpansionToggle={this.showExpandedActionMenu.bind(this)}
										expanded={false}
										useGreyIcon={true}
									/>
								</div>
							</>
						) : null}
						{showExpandedActionMenu && actionOptions ? (
							<div className="people-scheduling-actions-menu" style={{
								top: expandedActionMenuY,
								left: GROUP_SECTION_ACTIONS_MENU_LEFT_SCHEDULE_PEOPLE(),

							}}>
								<ActionMenu
									options={actionOptions}
									onExpansionToggle={this.hideExpandedActionMenu.bind(this)}
									expanded={true}
									useGreyIcon={true}
								/>
							</div>
						) : null}
						{showArrowClickableArea ? (
							<div
								className="people-scheduling-arrow-clickable-area previous"
								onClick={this.onTaskGroupArrowClick.bind(this, true)}
								style={{top: arrowClickableAreaY + 2}}
							/>
						) : null}
						{showArrowClickableArea ? (
							<div
								className="people-scheduling-arrow-clickable-area next"
								onClick={this.onTaskGroupArrowClick.bind(this, false)}
								style={{top: arrowClickableAreaY + 2}}
							/>
						) : null}
						{showDetailBox ? (
							<div
								className="people-scheduling-detail-box"
								style={{
									left: detailBoxX + 200 < window.innerWidth ? detailBoxX + 10 : detailBoxX - 235,
									top: detailBoxY + 350 < window.innerHeight ? detailBoxY - 5 : 'unset',
									bottom:
										detailBoxY + 350 < window.innerHeight ? 'unset' : window.innerHeight - detailBoxY - 40,
								}}
							>
								{detailBoxData.task ? (
									<TaskDetailBox
										task={detailBoxData.task}
										globalData={data}
										isPeopleScheduling={true}
										positionX={detailBoxX}
										positionY={detailBoxY}
									/>
								) : (
									<AllocationDetailBox
										taskAllocationTotalEstimate={detailBoxData.totalEstimates}
										allocation={detailBoxData.allocation}
										globalData={data}
										positionX={detailBoxX}
										positionY={detailBoxY}
									/>
								)}
							</div>
						) : null}
					</div>

					<CanvasTimeline
						ref={timeline => (this.timeline = timeline)}
						groups={groups}
						items={items}
						topLeftComponent={topLeftComponent}
						isCollapsableSectionExpanded={isCollapsableSectionExpanded}
						collapsableSectionGroups={collapsableSectionGroups}
						onVerticalScroll={this.onTimelineVerticalScroll.bind(this)}
						onHorizontalScroll={this.onTimelineHorizontalScroll.bind(this)}
						dayData={dayData}
						startDate={startDate}
						isSingleGroup={!hasPermission(PERMISSION_TYPE.SCHEDULING_ACCESS)}
						onGroupExpansionToggle={this.onGroupExpansionToggle.bind(this)}
						onRangeChange={this.onTimelineRangeChange.bind(this)}
						debugData={data}
						holidaysEntries={holidaysEntriesCanvasFormat}
						isProjectTimeline={this.props.isProjectTimeline}
						eyeOptions={peopleSchedulingDetailSelectorOptions}
						recalculateSteps={recalculateSteps}
						resetRecalculateSteps={this.resetRecalculateSteps.bind(this)}
						onForegroundContextMenu={this.onForegroundContextMenu.bind(this)}
						splitAllocationBarData={splitAllocationBarData.visible ? splitAllocationBarData : null}
						heatmapCache={this.heatmapCache}
						isUsingNewTRU={this.isUsingNewTRU}
						setPreventFiltering={this.setPreventFiltering.bind(this)}
						onBeforeHorizontalScroll={scrollAmount => preventScrollingPastLoadMoreOverlay(this, scrollAmount)}
						onDrawForegroundEnd={(canvasContext, _, stepDataArray) =>
							drawLoadMoreOverlay(this, canvasContext, stepDataArray)
						}
						isPeopleScheduling={true}
						isHeatMapDisabled={this.isHeatMapDisabled()}
						isUsing35Frames={this.isUsing35Frames}
						isUsing67Frames={this.isUsing67Frames}
						isUsingInstantZoom={this.isUsingInstantZoom}
						filterGroupOnHorizontalScroll={filterGroupOnHorizontalScroll}
						filterGroupOnZoom={filterGroupOnZoom}
					/>
					{this.state.savingMutation ? (
						<div className="is-saving">
							<div className="backdrop" style={{width, height, top, left}} />
							<div className="description">Saving. Please wait until it is finished.</div>
						</div>
					) : null}
				</div>

				<LoadMoreOverlay
					allDataLoaded={this.state.allDataLoaded}
					allDataLoading={this.state.allDataLoading}
					onLoadMore={() => {
						tracking.trackElementClicked('Load more');
						this.setState({allDataLoading: true});
						this.doFetchFullData(this.props, true);
					}}
				/>

				{/* userpilot targets */}
				<div
					className="onboarding-person-target"
					id="onboarding-scheduling-person-div"
					data-userpilot={'onboarding-scheduling-person-div'}
				/>
				<div
					className="onboarding-person-expand-target"
					id="onboarding-scheduling-person-expand-div"
					data-userpilot={'onboarding-scheduling-person-expand-div'}
				/>
				<div className="userpilot-target unassingned-tasks" data-userpilot={'unassingned-tasks'} />
				<div
					className="userpilot-target unassingned-tasks-expand-icon"
					data-userpilot={'unassingned-tasks-expand-icon'}
				/>
				<div
					className="userpilot-target unassigned-task"
					id="user-pilot-unassigned-task"
					data-userpilot={'unassigned-task'}
				/>
				<div className="userpilot-target first-role" data-userpilot={'first-role'} />
				<div className="userpilot-target first-person" data-userpilot={'first-person'} />
				<div className="userpilot-target first-person-expand-icon" data-userpilot={'first-person-expand-icon'} />
				<div
					className="userpilot-target first-person-expand-icon-project"
					data-userpilot={'first-person-expand-icon-project'}
				/>
				<div className="userpilot-target resource-utilization" data-userpilot={'resource-utilization'} />
				<div className="userpilot-target heatmap-first-project" data-userpilot={'heatmap-first-project'} />
				<div
					className="userpilot-target heatmap-fully-allocated"
					id="userpilot-heatmap-fully-allocated"
					data-userpilot={'heatmap-fully-allocated'}
				/>
				<div
					className="userpilot-target heatmap-over-allocated"
					id="userpilot-heatmap-over-allocated"
					data-userpilot={'heatmap-over-allocated'}
				/>
			</>
		);
	}
}

CanvasPeopleScheduling.propTypes = {
	setTimeline: PropTypes.func.isRequired,
};

export default injectIntl(withRouter(CanvasPeopleScheduling));
